import Colors from '../components/Common/colors'

const moduleList = [
  {
    metaDescription: 'Core HR',
    title: 'Core HR ',
    slug: 'core-hr',
    subTitle: 'The Most Intuitive HR System That Works Hard, So You Do Not Have To! Either its company structural dynamics or employees and their absenteeism management, WebHR has a solution for all of them. In fact, WebHR can be used to simplify the daily tasks involved in the HR Department.',
    // img: 'https://res.cloudinary.com/dpugxh9rw/image/upload/v1683803407/Video_Box_ushffm.png',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Core_HR.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'User Self-Service',
        sectionContent: 'WebHR is a multi-user role base system that lets you easily manage accessibility for your employees based on your company’s requirements. You can design as many role templates as possible like Employee Self Service (ESS), Manager Self Service (MSS), and Admin roles, and based on these roles, the system will assign access to the employees.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_0.webp',
        coreHRreview: true,
        demoButton: true,
      },

      section2: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Document Management',
        sectionContent: 'Managing employee documents is not an easy task, but with the help of WebHR, you can easily manage your employees and company’s documents.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_1.webp',
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Comprehensive Reports and Graphs',
        sectionContent:
          'WebHR contains a very detailed and extensive reporting module to provide ideal output for each entry input in the system, you don’t need to gather around the data to make company decisions or financial decisions, as with the help of WebHR comprehensive reports it will make it easy for you to analyze HR data and make the strategic decision. Each report that is generated from WebHR can be emailed or exported which allows you to share useful information with relevant stakeholders.',
          sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_2.webp',
        demoButton: true,
        tryWebHR: true,
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Available in 30+ languages',
        sectionContent: 'WebHR is a user-friendly software it gives you ease to customize the language of your WebHR account based on your native understanding.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_3.webp',
      },
      section5: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Mobile Application',
        sectionContent: 'What is more one can ask for is to have the HR process within the reach of their mobile, Yes! WebHR offers the most advanced Mobile App. Apply the leave application on the go, mark attendance or geographical attendance directly from mobile, and perform many more tasks like performance evaluation, and surveys from our app. Our WebHR mobile application is available on both Android and iOS.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_4.webp',
      },
      section6: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'What’s on your mind?',
        sectionContent: 'Socially connect with all your colleagues through WebHR. The social platform enables important announcements and employee instant recognition. It also lets you share your thoughts on social networks like LinkedIn and Facebook.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_5.webp',
      },
      section7: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Structural Dynamics',
        sectionContent: 'Design your organizational structure in the system to be assigned to employees like company, location, and departments. Manage structure/company-specific policies. Also, you can keep track of what changes are being made within the system with the help of system logs.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_6.webp',
      },
      section8: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Hire to Retire',
        sectionContent:
          'Once the employee is onboarded or leaving the company all tasks associated with the employee can be handled within WebHR. In WebHR you can manage major HR tasks such as Employee Profile Management, Assignments, Complaints, Travels, Transfers, Promotions, Resignations, Employee Exits, etc. Everything can be managed here. Also, manage disciplinary violations and issue warnings easily through WebHR. It allows organizations to automate almost all aspects of human resource management, with the twin benefits of reducing the workload of the HR department as well as increasing efficiency by standardizing HR processes.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_7.webp',
        actionButton: true,
      },
      section9: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Absenteeism Management:',
        sectionContent: 'Stay updated on real-time information regarding the attendance stats of the employees. Easily check who is on leave, and what is the sign-in and out trend. Not only this, but you can also define country-specific leave policies as per prevailing labor laws. WebHR has more than 15+ methods of attendance so you can choose which method is best for your company.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/core_hr/CoreHR_8.webp',
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'Employees time tracking in the most advanced way possible',
    title: 'Time and Attendance',
    slug: 'time-and-attendance',
    subTitle: 'WebHR provides the Easiest, Most Flexible, Most Advanced Time and Attendance Solution! ',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Time_&_Attendance.webp',
    video2: {
      videoThumb: 'https://res.cloudinary.com/dpugxh9rw/image/upload/v1684821924/time-attendance-thumb_nsnsm0.png',
      // video: 'https://cdn.webhr.co/Web/Video/WebHR_Modules_Timesheet.mp4',
    },
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
        },
        sectionHeading: "WebHR's seamless Time & Attendance Module will make your daily experience a breeze",
        sectionContent:
          'Employees can track time anywhere using an Android or iOS mobile phone, computer, tablet, or any device by the clock in and out. Administration and Management can see who is working, where and on what projects. All of this is done in real-time. Our Time & Attendance data can be seamlessly integrated with QuickBooks, Sage, Paychex, ADP, Xero, and more... Our Timesheet modules allow employees to easily take Lunch Breaks, Additional Breaks, and more. You can now dynamically control unforeseen compliance threats.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_01.webp',
        sectionAttendece: true,
        review: true,
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
          align: 'left',
        },
        sectionHeading: 'Attendance Methods',
        sectionContent:
          "One of the major challenges for HR departments is to get the attendance figures right and analyzed. Keeping track of every employee signing in and signing out has always been a major headache, be it a small/medium or even a large organization. In order to solve this issue, many organizations deploy a stand-alone hardware-based time tracking system, which works perfectly fine, but in the end, its someone's job to collect the data from attendance hardware and manually sort out the number of hours an employee spends in the office, a task that may take several hours of manual work, depending upon the number of employees.\n\nWebHR solves this problem by providing multiple attendance methods.\n\nHave a seamless and analyzed attendance through WebHR.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
        },
        sectionHeading: 'Mobile Attendance',
        sectionContent:
          "WebHR mobile app allows you to clock in wherever you are seamlessly with your Android or iOS device. Clock In, Clock Out, Lunch Break In and Out, Approve Hours, and more with just a few taps. Mobile Attendance captures GPS location (Latitude and Longitude) from the location they are clocking in from. The app allows Geo-Fence-based attendance, so employees can only clock in when they are within the station radius, let's say 100 meters radius of the office location. Mobile attendance also allows employees to optionally take photos of the location where they are clocking in from. Now you know exactly when and where the attendance is being marked. It is easier to keep track of the employees and stay coordinated with your teams, no matter where they are.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_03.webp',
        demoButton:true,
        buttonText:"Book a demo",
        tryWebHR: true,
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          align: 'left',
        },
        sectionHeading: 'Biometrics',
        sectionContent: 'We offer easy integration with Biometrics devices of ZK Techo and Anviz for fetching the attendance and keeping the data integrity as biometrics is considered most reliable method to mark authentic attendance.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_04.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgRed,
        },
        sectionHeading: 'Geofence',
        sectionContent: 'Experience the most advanced way of marking attendance from the ease of your mobile and the best thing is that it is authentic as it restricts employees to mark attendance if they are within the office location. Mobile Attendance captures GPS location (Latitude and Longitude). Now you know exactly, when and where the attendance is being marked. It is easier to keep track of the employees and stay coordinated with your teams, no matter where they are.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_05.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgGrey,
          align: 'left',
        },
        sectionHeading: 'IP Restriction',
        sectionContent: 'For ensuring that the employee marked attendance from office we provide another authentic way to ensure it from your office internet static IP.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_06.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section7: {
        attributes: {
          bg: Colors.bgGrey,
          align: 'left',
        },
        sectionHeading: 'Time Clock Kiosk',
        sectionContent: 'WebHR offers a physical time clock for you. Hook it up on an iPad or an Android Tablet and place it either in the reception area, building entrance, or a corner, to make it easy for your employees to clock in and out. Time Clock kiosks can allow clocking in for different projects or from different locations. Time Clock kiosks can take a photo of the person clocking in, so HR can do a random audit to avoid buddy punching.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_07.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      // section8: {
      //   attributes: {
      //     bg: Colors.bgBlue,
      //   },
      //   sectionHeading: 'Scheduler',
      //   sectionContent: 'If your company is having irregular work shifts and it’s difficult to manage employee attendance you can make the best use of our Scheduler method. Based on each day schedule system will analyze attendance that makes it most easy to manage the fluctuating shifts.',
      //   sectionImg1: 'https://res.cloudinary.com/dpugxh9rw/image/upload/v1681451371/eight_sbt2hd.png',
      // },
      section9: {
        attributes: {
          bg: Colors.bgRed,
          align: 'left',
        },
        sectionHeading: 'Dashboard Widget',
        sectionContent: 'Irrespective of any restriction if you want the employee to sign in and out from system you can easily manage that through our Dashboard widget.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_09.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section10: {
        attributes: {
          bg: Colors.bgGrey,
        },
        sectionHeading: 'Timeclock Window (Bar Code)',
        sectionContent: 'WebHR Time Clock is a built-in attendance link through which the employee can mark attendance and you can have different link for each of your office location. To avoid buddy punching you can capture a picture too at the time of marking the attendance of an employee',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_10.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section11: {
        attributes: {
          align: 'left',
          bg: Colors.bgBlue,
        },
        sectionHeading: 'Bulk Import',
        sectionContent: 'Easily import the attendance data in system through our bulk data import option.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_11.webp',
        actionButton: true,
      },
      section12: {
        attributes: {
          bg: Colors.bgRed,
        },
        sectionHeading: 'WebHR Reports',
        sectionContent: "Use vibrant reports to keep an audit trail of your calendar, time tables and budgets with real timesheet costs, sales operations, and other employee variables to keep your company on the high-speed path. WebHR's comprehensive and extensive reporting format allows you to get data intelligence as never experienced before.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/time_and_attendance/Timesheet_12.webp',
        isAttendenceEnd: true,
        demoButton:true,
        buttonText:"Try for free"
      },
    },
  },

  {
    metaDescription: 'Applicant Tracking System (ATS) to streamline your hiring process',
    title: 'Recruitment (ATS)',
    slug: 'recruitment',
    subTitle: "WebHR's Recruitment Module is like a magic wand for employers, bringing you a user-friendly, tailor-made applicant tracking system that snags the ideal hire for your biz. From job requests to posts on your site's careers page, candidates can apply, whip up a login on the Careers Portal, and finish their profile. WebHR auto-syncs the details, making the whole thing an easy victory. It handles everything from shortlisting and setting up interviews to sizing up and hiring peeps. And, you can even make evaluation standards for each job and can send candidate tests right there in the system. It's your all-in-one hiring hangout!",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Recruitment.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "WebHR helps you mainstream your recruitment and grow your business!",
        sectionContent: "Our aim is to help you keep all those candidates’ details neat and tidy throughout the hiring journey, so you can zero in on the perfect fit. With all the info in one central spot, everyone stays in the loop. Plus, with auto-notifications and our handy messenger, you'll stay connected and chat, whether you're browsing the web or out and about.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recruitment/Recruitment01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Simple, Seamless, and Highly Customizable Applicant Tracking System',
        sectionContent:
          "WebHR makes hiring very easy by linking up with your company's jobs portal and popular recruitment sites like Indeed, Glassdoor, and ZipRecruiter. When candidates apply, their applications and resumes pop right into your Recruitment module— effortless! You can check out applications, shortlist peeps, interview them, chat with them, and hire them based on their scores. Say goodbye to all that pesky paperwork and data entry, cause now you've got a one-stop platform to safely stash and track all those records.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recruitment/Recruitment02.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'WebHR makes Job Posting and Candidate Sourcing',
        sectionContent: "The recruitment module of WebHR allows HR teams to create and post job openings and share them across various platforms, including company websites, job boards, and social media. It simplifies the process of reaching a wide pool of candidates by automating job postings and distributing vacancies across multiple channels. Integrated candidate sourcing tools enable recruiters to search resume databases, professional networks, and external platforms, accelerating the identification of potential candidates.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recruitment/Recruitment03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'I’ve changed my applicant’s status to “Recruit”, now what?',
        sectionContent:
          "After getting hired, your new employees can jump right into self-onboarding, saving your company loads of time and effort. They can keep their records fresh, upload docs, and make sure all their info is up to date. Once they're in the system, employees can ask for PTO and stuff, and score approvals with just a few taps. WebHR's Recruitment module is a sweet integrated solution that chats with your WebHR Employee module, keeping all employee data safe and sound.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recruitment/Recruitment04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'A seamless way to manage the Candidate Interviews',
        sectionContent:
          "Managing interviews can be time-consuming or a complex task, especially when multiple interviewers and candidates are involved. The recruitment module simplifies interview scheduling and management by providing automated interview coordination and sending interview invitations, the candidates will receive the interview invite and details for the candidate portal.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recruitment/Recruitment05.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Recruitment Reports',
        sectionContent: "Data-driven insights play a crucial role in optimizing recruitment strategies. The recruitment module generates comprehensive reports and analytics on key recruitment metrics, such as time-to-fill, cost-per-hire, and source effectiveness. These insights enable HR teams to identify bottlenecks, assess the efficiency of recruitment channels, and make data-informed decisions to continuously improve the hiring process. From interviews to hiring, just schedule a free demo and check it out! WebHR provides you with more than 175 ready-to-go, exportable reports, so you'll always make smart HR recruitment choices at every stage.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recruitment/Recruitment06.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section7: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Centralized candidate data', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/01.svg"
          }, 
          {
            listItem:'Interface with your company’s job portal', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/02.svg"
          }, 
          {
            listItem:'Integration with external recruitment websites', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/03.svg"
          }, 
          {
            listItem:'Candidate screening and recruitment', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/04.svg"
          }, 
          {
            listItem:'Easily attach documents and notes', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/05.svg"
          },
          {
            listItem:'Publish Job Posts on job boards, websites, social media, etc.', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/06.svg"
          }, 
          {
            listItem:'Automatic notifications and messenger', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/07.svg"
          }, 
          {
            listItem:'Interview tests and forms', 
            image:"https://cdn.webhr.co/Website/images/modules/recruitment/key_features/08.svg"
          }
        ],
        isAttendenceEnd:true,
      },
    },
  },
  
  {
    metaDescription: 'Salary &amp; compensation made easy for everyone',
    title: 'Payroll Module',
    slug: 'payroll',
    subTitle: "Nail your payroll with your payroll calendar. Worried about all those troublesome tax calculations and employee payroll stuff that takes ages? Chill out! WebHR's got your back with payroll automation. Set up your payroll once, define salaries, and voila! One-click pay slips for your peeps on a pay period basis. WebHR's have global payroll for over 100 countries.",
    // img: 'https://cdn.webhr.co/images/Web/Modules/Payroll/Payroll.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Payroll.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
        },
        sectionHeading: 'Auto-calculations and deductions make payroll a breeze',
        sectionContent: "In WebHR, once you've set up your data, the payroll module crunches the numbers for you – from taxes and claims to benefit and leaves. Relax knowing every update gets auto calculated! Employees can check their payroll info anytime, and you'll have a dedicated account manager and support team to help you through the payroll process.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Payroll/Payroll03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
        },
        sectionHeading: 'Set up your payment schedule and process payroll easily',
        sectionContent: `Setting up your payment schedule is super simple. Set up direct deposit, print paychecks, or pay employees manually. Run your payroll smoothly and in an organized way. Once the payroll’s done, employees get an email with their pay slip details. Employees can always access their payroll info, so HR can focus on other stuff instead of answering questions.`,
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Payroll/Payroll01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
        },
        sectionHeading: 'Eliminate the need for manual calculation by using WebHR Payroll Module',
        sectionContent: "Save time and headaches with a payroll system that does the work for you. Streamline your payroll setup in no time with WebHR. Achieve admin efficiency, better data access, and improved payment accuracy with our payroll system. There are loads of options in the payroll setup, from daily payment methods, allowances, auto deductions, auto additions, and taxes – set them up to match your company policy.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Payroll/Payroll04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'WebHR is easily flexible and Customizable.',
        sectionContent: "We know managing employee salaries and taxes is tough, but with WebHR, just do a one-time setup and watch employee salary taxes get auto calculated (if your country's taxes are configured in WebHR).",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Payroll/Payroll02.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Payroll data reports',
        sectionContent: "You can generate comprehensive reports and analytics related to employee compensation, tax summaries, payroll expenses, and other financial aspects. These reports provide valuable insights into payroll trends and cost analysis. HR teams can leverage this data to make informed decisions and optimize payroll processes.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Payroll/Payroll05.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Complex Tax Calculation based on countries’ specific rules and regulations',
        sectionContent: "Managing complex tax calculations can be hard, but our payroll module simplifies the tax calculation by automatically withholding the appropriate amounts from employee paychecks based on applicable country-specific tax laws and regulations.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Payroll/Payroll06.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section7: {
        attributes: {
          bg: Colors.bgRed,

          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Centralized payroll data', 
            // https://cdn.webhr.co/Website/images/modules/Performance/Keyfeatures/02.svg
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/01.svg"
          }, 
          {
            listItem:'Quick and easy payroll processing', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/02.svg"
          }, 
          {
            listItem:'Multiple payroll setups payroll data', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/03.svg"
          }, 
          {
            listItem:'Different currency options', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/04.svg"
          }, 
          {
            listItem:'Auto-Calculation of PTO, taxes, expenses, etc.', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/05.svg"
          }, 
          {
            listItem:'Auto payslip detail notifications', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/06.svg"
          }, 
          {
            listItem:'Various payslip formats', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/07.svg"}, 
          {
            listItem:'Compliance reports', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/08.svg"
          }, 
          {
            listItem:'Pay schedules', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/09.svg"
          }, 
          {
            listItem:'Payroll data reports.', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/10.svg"
          }, 
          {
            listItem:'Direct deposit ',
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/11.svg"
            }, 
          {
            listItem:'Paycheck processing ', 
            image:"https://cdn.webhr.co/Website/images/modules/payroll/key_features/12.svg"
        }
        ],
        isAttendenceEnd: true,
        
      },
    },
  },

  {
    metaDescription: '360 Degrees Employees Appraisals &amp; Evaluations',
    title: ' Performance',
    slug: 'performance',
    subTitle: 'Track Your Employees Performance with 360 Degree Performance Module',

    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Performance.webp',
    video1: {
      videoThumb: 'https://cdn.webhr.co/Web/Video/WebHR_Modules_Performance.jpg',
      video: 'https://cdn.webhr.co/Web/Video/WebHR_Modules_Performance.mp4',
    },
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Customize Your Performance Evaluation Templates',
        sectionContent:
          "With WebHR, you can whip up performance evaluation templates, packed with objectives, KPIs, competencies, and more. Create an amazing appraisal form that works for you! Employees or managers can write KPIs, and once they're finalized, they're ready for evaluation. Automate the whole process by having employees and managers write objectives and KPIs, and then auto-route them for self, manager, peer, and final reviewer assessments. Design your performance review using objectives, KPIs, weightage, personal development, and competency indicators to suit your needs.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Performance/Performance_03.webp',
        // list:["Performance Matrix", "Completion Status", "Review pie chart"],
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'The Dashboard shows a visual summary of all the data in different formats. ',
        sectionContent: 'The dashboard displays the review process and status updates of every employee. Other tabs allow you to view the status of all the reviews generated within the system. This module allows you to run reports on the reviews completed by your employees to ensure the efficiency of performance reviews assignment and completion.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Performance/Performance_04.webp',
        // list:["Customizable Reports", "Personalized Reports", "Review Pie Chart"],
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Easily Design and Assign Employee Performance Reviews',
        sectionContent: "Need special reviews to catch performance issues before they blow up? No problem! The Performance module lets you design and assign extra reviews whenever you need them.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Performance/Performance_02.webp',
        // list:["Customizable Reports", "Personalized Reports", "Review Pie Chart"],
        demoButton:true,
        buttonText:"Book a demo"

      },
      section4: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Automatic Notifications and In-Depth Performance Reports',
        sectionContent: "Our reporting system gives you the tools to look up your employees' performance, keep them engaged, and make them feel valued. Automated reminders and notifications mean evaluations and reviews are always done on time, keeping you ahead of the game. Why do you need a Performance Module? Ask yourself: Do you want to boost employee performance and productivity? Align employee goals with your company's vision and strategy. Give feedback and recognition, helping your team grow. If so, WebHR's got your back with its all-in-one Performance module.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Performance/Performance_01.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:false,
      },
      section5: {
      attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'360 degrees performance reviews', 
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/01.svg"
          }, 
          {
            listItem:'Define KPI, personal development, and competency indicators for Performance Reviews', 
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/02.svg"
          }, 
          {
            listItem:'Centralized employee performance data', 
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/03.svg"
          }, 
          {
            listItem:
            'Performance Reviews', 
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/04.svg"
          }, 
          {
            listItem:'Analyze employee performance data and insights', 
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/05.svg"
          }, 
          {
            listItem:'Easy Performance review designer with user-friendly forms and assessments', 
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/06.svg"
          }, 
          {
            listItem:'Automated reminders and notifications', 
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/07.svg"
          },
          {
            listItem:'Comprehensive performance review reporting system',
            image:"https://cdn.webhr.co/Website/images/modules/performance/key_features/08.svg"
          }
        ],
        isAttendenceEnd: true,
      },
    },
  },
 
  {
    metaDescription: 'Administer and Monitor your Employee Benefits',
    title: ' Benefits',
    slug: 'benefits',
    subTitle: "WebHR's Benefits Management and Administration: Comprehensive Coverage for Your Workforce The WebHR Benefits Module empowers businesses to effectively manage benefits plans and claims, enhancing the employee experience and promoting their well-being. With this module, you can effortlessly create benefits plans and enable employee self-enrollment while accessing comprehensive reports on all benefit plans, enrollments, and claims.",
    // img: 'https://cdn.webhr.co/images/Web/Modules/Benefits/Benefits.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Benefits.webp',
    video1: {
      videoThumb: 'https://cdn.webhr.co/Web/Video/WebHR_Modules_Benefits.jpg',
      video: 'https://cdn.webhr.co/Web/Video/WebHR_Modules_Benefits.mp4',
    },
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'In-depth Benefits Plan Management',
        sectionContent: "The Benefits module accommodates an extensive array of benefits plans, including health, dental, and life insurance, among others. WebHR provides a centralized location to add and manage plan details and coverage information, simplifying benefits plan oversight.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/benefits/benefits_illustration01.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: "WebHR's Benefits Module: An All-in-One Solution for Optimum Efficiency",
        sectionContent: "Our module is a self-service benefits administration tool, allowing for efficient benefits plan management. It enables employees to easily compare, select, and enroll in their preferred benefits plans, saving you precious time and resources",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/benefits/benefits_illustration02.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Streamlined Employee Enrollment Management',
        sectionContent: "Our module simplifies the process of enrolling employees in benefits plans within specific periods. Set up enrollment periods and deadlines easily, ensuring organized and transparent management of enrollment records. Moreover, WebHR also supports open enrollment periods, granting employees the freedom to review and update their enrollment information.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/benefits/benefits_illustration03.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Effortless Claim Submissions with WebHR',
        sectionContent: "WebHR's Benefits module enhances claims management by allowing employees to submit and track their benefits claims within the system. You can monitor claim statuses, ensuring timely claim reimbursements. Define workflows and notifications for each claim type, boosting efficiency and streamlining the claims process.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/benefits/benefits_illustration04.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Integrated Reporting in Real-Time',
        sectionContent: "As a unified platform, WebHR ensures that any changes sync automatically across the system, guaranteeing up-to-date and accurate data. Generate critical reports, from benefits claims to employee enrollment, with just a few clicks.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/benefits/benefits_illustration05.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
      attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Comprehensive benefits administration and management', 
            image:"https://cdn.webhr.co/Website/images/modules/benefits/key_features/01.svg"
          },
          {
            listItem:'Centralized repository for all employee and company benefits data', 
            image:"https://cdn.webhr.co/Website/images/modules/benefits/key_features/02.svg"
          },
          {
            listItem:'Simple, quick enrollment process', 
            image:"https://cdn.webhr.co/Website/images/modules/benefits/key_features/03.svg"
          },
          {
            listItem:'Notifications for employees about online enrollment', 
            image:"https://cdn.webhr.co/Website/images/modules/benefits/key_features/04.svg"
          },
          {
            listItem:'Comprehensive benefits reports', 
            image:"https://cdn.webhr.co/Website/images/modules/benefits/key_features/05.svg"
          }, 
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'eSign all necessary paperwork, compliance and other documents',
    title: ' E-Signature',
    slug: 'eSignature',
    subTitle: 'Easily Create and Insert Your Electronic Signature Wherever It’s Virtually Needed! eSiganture module of WebHR lets employees create an electronic signature, through which important documents can be sent and signed on the go. Any important document, offer, or promotion letter can be sent to employees, managers, or supervisors to get e-signed from anywhere. Not only this but most WebHR submodule records can be sent to be eSigned from the Relevant Authorities.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/eSignature/eSignature.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery//ESignature.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Save Your Company’s Time, Money, and the Environment',
        sectionContent: 'With WebHR eSignature, you can upload your company-specific documents, you can send them to your employees for digital signature in seconds and track their progress until completion.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/e_signature/e_signature_illustration01.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'WebHR Helps you to Streamline the Document Signing Processes',
        sectionContent:
          'The WebHR eSignature module lets you sign documents electronically from anywhere any time, by using any device with an internet connection. This eliminates the need for in-person meetings or mailing the documents. Additionally, it is typically more secure than traditional signing methods because it uses encryption and authentication protocols to ensure the integrity of signed documents. This helps to prevent fraud, unauthorized alterations, and document tampering.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/e_signature/e_signature_illustration02.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'E-Signature Notifications and Reports Keep You on Track',
        sectionContent: 'Employees are automatically notified once a document has been sent for digital signature. Every time you log in to WebHR, you will get an alert that you have outstanding forms or papers to sign. From W-4 to I-9, WebHR’s eSignature tool can handle all your administrative paperwork. Comprehensive reports within the module provide timely information briefly so that you are always on track and ahead of your deadlines. Signed document reports determine which documents are complete and which are still pending, so you can prevent compliance bottlenecks and keep your administration procedures moving along.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/e_signature/e_signature_illustration03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Automatic Document Storage and Easy Retrieval',
        sectionContent: 'Every document signed by an employee using our eSignature module is automatically stored in the dashboard and can also be stored under the employee’s documents folder within their file. Employees will always have access to their signed documents through their account without the need to disrupt the HR administration department.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/e_signature/e_signature_illustration04.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Electronic signature of any document', 
            image:"https://cdn.webhr.co/Website/images/modules/e_signature/key_features/01.svg"
          },
          {
            listItem:'Centralized e-signed documents data', 
            image:"https://cdn.webhr.co/Website/images/modules/e_signature/key_features/02.svg"
          },
          {
            listItem:'Safe and secure document storage', 
            image:"https://cdn.webhr.co/Website/images/modules/e_signature/key_features/03.svg"
          },
          {
            listItem:'Track document progress', 
            image:"https://cdn.webhr.co/Website/images/modules/e_signature/key_features/04.svg"
          },
          {
            listItem:'Easy access to your signed documents', 
            image:"https://cdn.webhr.co/Website/images/modules/e_signature/key_features/05.svg"
          },
          {
            listItem:'Employee notifications and alerts', 
            image:"https://cdn.webhr.co/Website/images/modules/e_signature/key_features/06.svg"
          },
          {
            listItem:'Comprehensive reporting system', 
            image:"https://cdn.webhr.co/Website/images/modules/e_signature/key_features/07.svg"
          },
        ],
        isAttendenceEnd: true,
      },
      
    },
  },
  {
    metaDescription: 'Seamless onboarding with all necessary initial steps',
    title: 'Onboarding Module',
    slug: 'onboarding',
    subTitle: 'Streamlined Solution for New Hire Integration.In the realm of talent management, efficient onboarding, and offboarding procedures are paramount. They ensure seamless transitions for incoming and outgoing employees. WebHR presents an innovative onboarding solution that simplifies your recruitment process, facilitating tasks like creating checklists, sending notifications, and building employee profiles.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Onboarding/Onboarding.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Onboarding.webp',
    video1: {
      videoThumb: 'https://cdn.webhr.co/Web/Video/WebHR_Modules_Onboarding.jpg',
      video: 'https://cdn.webhr.co/Web/Video/WebHR_Modules_Onboarding.mp4',
    },
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Essential Onboarding Tasks:",
        sectionContent: "WebHR's onboarding system makes the employee enrollment process straightforward and efficient. New hires follow a smart wizard that prompts them through all steps, helping them populate the information that is securely stored. This streamlined procedure is convenient for both employees and employers, culminating in administrators approving and archiving the data",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Onboarding/Onboarding_01.webp',
        list:["Review & Sign Offer Letter: An auto-generated offer letter is sent to the new hire for review and electronic signature.", "Online Training: New hires have access to all necessary online training for seamless onboarding.", "Benefits Enrollment: New employees have the freedom to choose their preferred benefits plans.", "Company Policy Acknowledgement: New hires are provided with the opportunity to review all company policies and acknowledge them by signing off.", "Electronic Document Signing: Enable new hires to electronically sign required documents. (W-4, I-9, etc.)", "Form & Paperwork Completion: Send out initial paperwork with a specific workflow, such as a direct deposit authorization form.", "Personal Information Submission: Gather all personal information from the new hire, including banking details, dependents' information, and more.", "Document Upload: New hires can upload necessary documents such as a driver’s license, passport, and latest resume."],
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Automate Documentation and Forms with the Onboarding Module: ',
        sectionContent:"The WebHR’s onboarding module simplifies the paperwork process by automating the creation and distribution of critical documents, like employment contracts and tax forms. This automation reduces manual errors, saves time, and streamlines the HR team's administrative tasks, enabling new employees to complete necessary paperwork digitally.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Onboarding/Onboarding_02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Efficient Management of Employee Tasks, Training, and Checklists: ',
        sectionContent:"The Onboarding module enables a structured onboarding experience by providing orientation materials, training resources, and company policies. New hires can easily navigate through these resources, acclimatizing themselves with the organization's culture and values. This HR software also allows managers to monitor the progress of new hires, ensuring that they receive necessary guidance. The module also facilitates the creation of task assignments and checklists, which include activities like obtaining security access and setting up email accounts. Automated reminders help both HR and new employees stay on track, ensuring a seamless onboarding experience. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Onboarding/Onboarding_03.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'The Impact of WebHR Onboarding: ',
        sectionContent:"This module offers a comprehensive solution to streamline the employee transition process. By automating administrative tasks, facilitating knowledge transfer, and enhancing employee experiences, the module contributes to increased efficiency, improved engagement, and compliance adherence. This technological embrace empowers HR teams to focus on strategic initiatives while fostering a positive experience for employees at every stage of their journey.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Onboarding/Onboarding_00.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Digital Document Management',
            image:"https://cdn.webhr.co/Website/images/modules/Onboarding/Keyfeatures/01.svg"
          },  
          {
            listItem:'Streamlined, Effortless Process',
            image:"https://cdn.webhr.co/Website/images/modules/Onboarding/Keyfeatures/02.svg"
          }, 
          {
            listItem:'Efficient Management of Employee Tasks',
            image:"https://cdn.webhr.co/Website/images/modules/Onboarding/Keyfeatures/03.svg"
          }
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'A Comprehensive Shift Planner for Employees Who are Not on Regular Schedulesay',
    title: ' Scheduler',
    slug: 'scheduler',
    subTitle: "A Complete Shift Planner for Flexible Work Schedules. WebHR's Scheduler module is an all-encompassing shift planner designed specifically for employees with variable work schedules. This feature enables the creation, management, and optimization of employee schedules, transforming the demanding task of workforce scheduling into a simplified process. By optimizing workforce management, the Scheduler module enhances operational efficiency and boosts employee satisfaction.",
    // img: 'https://cdn.webhr.co/images/Web/Modules/Scheduler/Scheduler.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Scheduler.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Live Updates with WebHR Scheduler Module',
        sectionContent: 'The Scheduler module facilitates real-time modifications to employee schedules. Changes including shift swaps, time-off requests, or shift cancellations are promptly updated across the system, ensuring that all employees have the most current schedule information, thus eliminating confusion and enhancing communication efficiency. ',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Scheduler/Scheduler01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Tailored Shift Planning for Non-ReguIar Work Schedules',
        sectionContent: "The module facilitates instant viewing of team availability and effortless planning of shift schedules, assigned stations, and projects. Employees have the flexibility to view, accept, or edit their schedules anytime, anywhere. You can create, modify existing shifts, and notify employees when a new schedule is posted, all with simple drag-and-drop functionality. Real-time monitoring of employee activities allows for efficient oversight of the workforce.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Scheduler/Scheduler02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Intuitive Scheduler Dashboard',
        sectionContent: "The Scheduler module's main screen displays a weekly calendar where users can add, copy, or import shifts, as well as approve schedules. Employees can conveniently mark their availability, while employers can create open shifts for self-scheduling as availability arises. \n\n This module allows you to generate multiple schedule reports which can be printed, emailed, exported, or saved as needed, like other reports within the system.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Scheduler/Scheduler03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Empowering Employees with Easy Access',
        sectionContent: "The Scheduler module includes a self-service feature, enabling employees to view their schedules, request time off, or swap shifts at their convenience. This level of control promotes employee satisfaction and engagement. Additionally, mobile access offers the flexibility to view schedules on the go, thereby eliminating communication hurdles.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Scheduler/Scheduler04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Promoting Work-Life Balance through Efficient Scheduling',
        sectionContent: "The Scheduler module allows the addition of open shifts, providing employees the freedom to choose shifts based on their preference and availability. This leads to a fair distribution of shifts, fostering a positive work environment, enhancing employee satisfaction, and reducing turnover rates. Mobile access and self-service features provide employees with autonomy and flexibility in managing their schedules.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Scheduler/Scheduler05.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Centralized scheduling data', 
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/01.svg"
          }, 
          {
            listItem:'Shift planning and scheduling',
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/02.svg"
            
          }, 
          {
            listItem:'Schedule notifications',
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/03.svg"
            
          }, 
          {
            listItem:'Open shifts and self scheduling',
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/04.svg"
          }, 
          {
            listItem:'Easily copy schedule with a drag and drop tool',
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/05.svg"
          }, 
          {
            listItem:'Schedule bulk upload and update',
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/06.svg"

          }, 
          {
            listItem:'Schedule publishing on main calendar',
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/07.svg"
            
          }, 
          {
            listItem:'Schedule reports',
            image:"https://cdn.webhr.co/Website/images/modules/scheduler/key_features/08.svg"
        }],
        isAttendenceEnd: true,
        
      },
    },
  },
  {
    metaDescription: 'Effectively Plan and Manage your Company and Employees (SMART) Goals',
    title: ' Goals',
    slug: 'goals',
    subTitle: 'Every successful organization understands the significant importance of Goals. They serve as a guiding light, harmonizing individual employees’ objectives with the company’s larger mission. The Goals module is instrumental in setting, tracking, and overseeing targets at both personal and group levels. By encouraging a culture grounded in responsibility, collaboration, and the pursuit of excellence, the WebHR Goals module propels a cooperative and clear interaction around organizational and team objectives. It provides an avenue for employees to formulate, disseminate, follow, and achieve their goals efficiently',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Goals/Goals.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Goals.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Creating Clear and Attainable Goals',
        sectionContent:
          "Our Goals module facilitates strategic tracking of objectives, illustrating the anticipated outcomes your company wishes to realize from its employees. Businesses flourish when they're guided by well-defined goals. They not only provide a clear lens into an individual's progress but also present a comprehensive view of the performance of each location, department, and division, painting a complete picture of company-wide performance.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/goals/goals_illustration01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Setting and Allocating Organizational Goals',
        sectionContent:
          "The Goals module offers an excellent platform to establish organizational objectives and delegate them to employees. This ensures that everyone's personal goals dovetail with the strategic intentions of the organization, promoting clear comprehension of priorities, enhancing focus, and instilling a sense of purpose among employees. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/goals/goals_illustration02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Facilitating Comments and Feedback',
        sectionContent:
          "Our Goals module enables comment and feedback functionality, allowing employees to contribute insights, share ideas, and support their colleagues' goals. This feature cultivates collaboration, nurtures a culture of constant improvement, and encourages employees to seek and offer invaluable feedback.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/goals/goals_illustration03.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Interconnection with Performance Management Add-On Module',
        sectionContent:
          "The Goals module forms an integral link with WebHR's Performance module, ensuring a seamless relationship between the accomplishments of set goals and performance appraisals. This interconnected functionality aids in evaluating and quantifying the influence of successful goal attainment on the broader framework of organizational performance. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/goals/goals_illustration04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Employing the SMART Goal Framework',
        sectionContent:
          "The Goals module of WebHR ingeniously incorporates the SMART goal framework - an acronym representing Specific, Measurable, Achievable, Relevant, and Time-bound. This model provides an invaluable guide to you and HR managers in establishing objectives that are explicit, assessable, attainable, pertinent to the individual's role, and constricted by a deadline. By following this SMART approach, the module guarantees that set goals are substantial and within the realm of achievement.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/goals/goals_illustration05.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
        },
        sectionHeading: '',
        sectionList: [
          {
            listItem:'Specific: simple, sensible, significant', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/01.svg"
          },
          {
            listItem:'Measurable: meaningful, motivating', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/02.svg"
          },
          {
            listItem:'Achievable: agreed, attainable', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/03.svg"
          },
          {
            listItem:'Relevant: reasonable, realistic, resourced, results-based', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/04.svg"
          },
          {
            listItem:'Time-bound: time-based, time-limited, time/cost limited, timely, time-sensitive', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/05.svg"
          },
          {
            listItem:'Progress Tracking and Monitoring', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/06.svg"
          },
          {
            listItem:'Setting and Delegating Organizational Goals', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/07.svg"
          },
          {
            listItem:'Reporting and Analytics', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/08.svg"
          },
          {
            listItem:'Goal Progress Tracking', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/09.svg"
          },
          {
            listItem:'Commenting and Feedback ', 
            image:"https://cdn.webhr.co/Website/images/modules/goals/key_features/10.svg"
          }, 
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'Eliminate Your Paperwork by Automating all Your HR and Non-HR Forms',
    title: ' Forms',
    slug: 'forms',
    subTitle: 'WebHR offers a hassle-free system for you to manage the forms that are being managed on your desktop. WebHR forms module provides a convenient and efficient way for employees to fill out company forms electronically. It simplifies the process of collecting and managing data, reduces administrative tasks, and ensures data accuracy and compliance. With the help of the Forms module, you can streamline the employee form data collection process, enhance employee experience, and maintain accurate and secure employee documentation.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Forms/Forms.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Forms.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Conditional Logic',
        sectionContent:
          'In the forms module, you can define the logics that enables forms to dynamically adjust based on the previous response, these conditions will allow the display or hide the specific questions based on employee input making the form more personalized and relevant. The form module ensures that employees see questions applicable to their situation at the time of filling out the form.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/forms/forms_illustration01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Customizable Form Templates',
        sectionContent: 'The Forms module offers a range of customizable templates that you can use to create different types of forms and add conditionals/logic as per your requirements. You can create multiple form templates based on specific requirements, including employee recruitment forms, performance appraisal forms, disciplinary forms, and more. The ability to customize forms ensures that organizations can capture relevant data and align it with their unique processes.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/forms/forms_illustration02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Document Upload Capability',
        sectionContent: 'The forms module of WebHR gives employees the feasibility to upload the relevant or supporting documents at the time of filling out the form. By enabling document upload, the form module consolidates all necessary information in one place, simplifying form completion and documentation.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/forms/forms_illustration03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Eliminate the Need for Paper-based Forms',
        sectionContent: 'WebHR provides you with the ease to send reminders and notifications for pending forms that are approaching the deadline. This reminder helps you to ensure that employees submit their forms in a timely manner, this minizines the risk of missing the deadline and improves overall efficiency..',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/forms/forms_illustration04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Forms Reminders and Notifications',
        sectionContent: 'WebHR provides you with the ease to send reminders and notifications for pending forms that are approaching the deadline. This reminder helps you to ensure that employees submit their forms in a timely manner, this minizines the risk of missing the deadline and improves overall efficiency.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/forms/forms_illustration05.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Reaching Your External Parties',
        sectionContent: 'The Forms module allows you to create or upload forms and send them to individuals outside the company, such as vendors, clients, etc. Within the Forms module, you can view, print, delete, and edit any form. You can email the forms as well as export them in various formats. You can set up approval processes for the forms completed by the employees. You can save the forms in the employees’ documents and give employees access to their forms.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/forms/forms_illustration06.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section7: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Forms Document Management and Storage',
        sectionContent: 'WebHR forms module enables you to create digital forms within the system, this eliminates the need for paper-based forms. Once you have created the forms template you can send those forms within the system or via email. This module accelerates the form distribution process, reduces paperwork, and ensures a consistent and standardized approach to data collection.',
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/forms/forms_illustration07.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section8: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Customizable Templates', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/01.svg"
          },
          {
            listItem:'Forms Document Management', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/02.svg"
          },
          {
            listItem:'Reminders and Notifications', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/03.svg"
          },
          {
            listItem:'Digital Form Accessibility', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/04.svg"
          },
          {
            listItem:'Conditional Logic', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/05.svg"
          },
          {
            listItem:'Real-time Form Updates', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/06.svg"
          },
          {
            listItem:'Performance form', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/07.svg"
          },
          {
            listItem:'External form',  
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/08.svg"
          },
          {
            listItem:'Employee form',  
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/09.svg"
          },
          {
            listItem:'Job Candidate form',
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/10.svg"
          },
          {
            listItem:'Employee Exit form', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/11.svg"
          },
          {
            listItem:'Training Evaluation Forms', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/12.svg"
          },
          {
            listItem:'Disciplinary forms', 
            image:"https://cdn.webhr.co/Website/images/modules/forms/key_features/13.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'Easily Design and Assign Any Company Specific Employee Survey ',
    title: ' Surveys',
    slug: 'surveys',
    subTitle: 'Feedback propels growth; in every organization, an effective survey can be the keystone to unlocking that growth. The Survey Module of WebHR serves as your tool to gather, interpret, and act on valuable employee feedback. It provides you with a platform to seamlessly create and manage surveys, enabling you to collect precious insights, gauge employee engagement, and make informed decisions to enhance the working environment.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Surveys/Surveys.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Surveys.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Connect and Engage with Your Most Valuable Assets - Your Employees',
        sectionContent: "With WebHR, you now have a powerful tool at your disposal to receive more feedback from your workforce. Our surveys provide the management with a comprehensive perspective of employees' sentiments about various aspects such as working conditions, leadership impact, motivation, and more, aspects that may not surface through regular communication channels. Properly executed, these surveys c",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Surveys/01.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Craft Custom Survey Forms Tailored to Your Needs',
        sectionContent: "Within the system, you have the flexibility to design various survey forms that align with your organization's unique requirements. Our Survey module offers a plethora of question types including star ratings, multiple choices, open-ended questions, and ratio ratings, equipping you to create comprehensive surveys that capture meaningful and actionable employee feedback.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Surveys/02.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Schedule for free demo"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Uphold Anonymity, Encourage Honesty',
        sectionContent: "To foster a climate of trust and encourage candid feedback, our Survey module gives employees the option to submit their responses anonymously. This ensures that their insights are shared freely, without fear of retaliation, while you can gather and analyze honest feedback, thereby strengthening the organization's culture of trust and openness.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Surveys/03.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Effortlessly Disseminate Employee Surveys',
        sectionContent: "Our module allows you to send surveys within the system itself. While dispatching the survey, you have the option to select your target audience, from specific employee groups to entire departments or stations.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Surveys/04.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
          align: 'left',
        },
        sectionHeading: 'Instant Insights with Real-time Analysis',
        sectionContent: "WebHR's Survey module provides real-time data capture, enabling you instant access to survey results. You can monitor response rates and generate insightful reports complete with graphical and tabular representations. This immediate access to feedback promotes proactive decision-making and prompt actions.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Surveys/05.webp',
        // list:["End-to-end solution", "Customizable system", "Embedded tax law", "Effective results"],
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Custom Survey Form Design', 
            image:"https://cdn.webhr.co/Website/images/modules/surveys/key_features/03.svg"
          },
          {
            listItem:'Anonymous Survey Submission', 
            image:"https://cdn.webhr.co/Website/images/modules/surveys/key_features/05.svg"
          },
          {
            listItem:'Real-time Data Collection', 
            image:"https://cdn.webhr.co/Website/images/modules/surveys/key_features/04.svg"
          },
          {
            listItem:'Survey Notifications', 
            image:"https://cdn.webhr.co/Website/images/modules/surveys/key_features/01.svg"
          },
          {
            listItem:'Comprehensive Survey Analytics', 
            image:"https://cdn.webhr.co/Website/images/modules/surveys/key_features/02.svg"
          }, 
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'Interface with Biometrics devices for the most accurate Time & Attendance',
    title: ' Biometrics',
    slug: 'biometrics',
    subTitle: "Biometrics attendance stops buddy punching and ditches paper-based monitoring. WebHR's Biometrics module lets you integrate your biometric gadgets into your WebHR account for accurate and safe time and attendance management. Biometric devices check employees' identity using unique biological features like fingerprints, facial recognition, voice patterns, or iris recognition. This way, you can stop buddy punches and pay employees only for the time they work. ",
    // img: 'https://cdn.webhr.co/images/Web/Modules/Biometrics/Biometrics.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Biometrics.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Biometrics.',
        sectionContent:
          "WebHR's Biometrics module lets you integrate your biometric gadgets into your WebHR account for accurate and safe time and attendance management. Biometric devices check employees' identity using unique biological features like fingerprints, facial recognition, voice patterns, or iris recognition. This way, you can stop buddy punches and pay employees only for the time they work.\n\n To use the Biometrics module in WebHR, follow these steps:",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Biometrics/Biometrics00.webp',
        list:["Add your biometric user credentials to your WebHR account with your username, password, time zone, and device.", "Manage employee access codes (biometric IDs) in the Timesheet module / Attendance / Settings. Download and install the WebHR Biometric Application on your computer or laptop and provide your organization code and biometric user credentials.", "Manually or automatically transfer attendance data from your biometric devices to your WebHR account. Once your biometrics device is connected to WebHR, the system will auto-capture employee attendance without any fuss.", "Manually or automatically transfer attendance data from your biometric devices to your WebHR account.Once your biometrics device is connected to WebHR, the system will auto-capture employee attendance without any fuss."],
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Accurate data',
            image:"https://cdn.webhr.co/Website/images/modules/biometrics/key_features/01.svg"
          }, 
          {
            listItem:"Stops buddy punching/Proxy Attendance",
            image:"https://cdn.webhr.co/Website/images/modules/biometrics/key_features/02.svg"
          },
          { 
           listItem: "Quick employee verification",
           image:"https://cdn.webhr.co/Website/images/modules/biometrics/key_features/03.svg"
          }, 
          {
            listItem:"Can store and verify loads of fingerprints",
            image:"https://cdn.webhr.co/Website/images/modules/biometrics/key_features/04.svg"
          }, 
          {
            listItem:"Keeps things super secure",
            image:"https://cdn.webhr.co/Website/images/modules/biometrics/key_features/05.svg"
          }, 
          {
            listItem:"Simple to use",
            image:"https://cdn.webhr.co/Website/images/modules/biometrics/key_features/06.svg"
          },  
          {
            listItem:"Easy to track employee attendance",
            image:"https://cdn.webhr.co/Website/images/modules/biometrics/key_features/07.svg"
          }],
        isAttendenceEnd:true,
      },
    }
  },
  {
    metaDescription: 'A Complete Learning Management System for All Your Training Needs ',
    title: ' Trainings',
    slug: 'trainings',
    subTitle: 'The training module of WebHR helps to streamline and enhance employee training and development processes within an organization, with a powerful and intuitive training designer and you will have the ability to assign training to your employees, you can track your employee’s personal development, generate training completion certificates, and run comprehensive reports to help you accomplish your company’s vision, mission, and goals.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Trainings/Trainings.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Trainings.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Training Needs Assessment',
        sectionContent:
          "The Training module enables you to conduct comprehensive training needs assessment of employees. From this, you can identify skill gaps, evaluate employee competencies, and determine the training requirements of an individual, team, or organizational level. This module helps you to ensure that training programs are aligned with specific development needs, maximizing the effectiveness of training initiatives.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Trainings/01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Managing the Training Course Catalog and Content',
        sectionContent:
          "WebHR Training module offers you a centralized course catalog where you can store and manage training materials, course descriptions/details, learning resources, and course tests. This simplifies the process of accessing and distributing the training material to the employees.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Trainings/02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Training Assessments and Feedback Form',
        sectionContent:
          "The WebHR training module makes it easy for you to evaluate employee learning outcomes and gather feedback on the training programs. You can create a quiz for individual training records, send feedback forms to assess knowledge retention, gather insights, and identify the gaps for improvement in training initiatives.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Trainings/03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Training Needs Assessment and Reporting',
        sectionContent:
          "The Training module allows you to access training information and generate the necessary reports to determine your training needs and the training development needed to help your employees and the company accomplish their goals and objectives. These analytics help assess the effectiveness of training programs, identify skill gaps, and make data-driven decisions for future training initiatives.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Trainings/04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Through WebHR you can easily see the Training Progress and Competency Tracking',
        sectionContent:
          "You can easily track the employee training progress, such as monitoring the training completion status, checking the course test results, etc. This allows you to identify which employee is performing well, track skill development, and make informed decisions about promotions and career paths.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Trainings/05.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Training course designer with Document and Video attaching capacity ', 
            image:"https://cdn.webhr.co/Website/images/modules/trainings/key_features/01.svg"
          },
          {
            listItem:'Centralized training and trainer data', 
            image:"https://cdn.webhr.co/Website/images/modules/trainings/key_features/02.svg"
          },
          {
            listItem:'Training Progress and Competency Tracking', 
            image:"https://cdn.webhr.co/Website/images/modules/trainings/key_features/03.svg"
          },
          {
            listItem:'Training completion certificate', 
            image:"https://cdn.webhr.co/Website/images/modules/trainings/key_features/04.svg"
          },
          {
            listItem:'Training needs Assessment and Assignment', 
            image:"https://cdn.webhr.co/Website/images/modules/trainings/key_features/05.svg"
          },
          {
            listItem:'Training evaluation and reporting', 
            image:"https://cdn.webhr.co/Website/images/modules/trainings/key_features/06.svg"
          },
        ],
        isAttendenceEnd: true,
      }
    },
  },
  {
    metaDescription: 'Organize and Track all Your Events and Activities with the Organization Calendar',
    title: ' Calendar',
    slug: 'calendar',
    subTitle: 'WebHR offers a hassle-free system for you to manage the forms that are being managed on your desktop. WebHR forms module provides a convenient and efficient way for employees to fill out company forms electronically. It simplifies the process of collecting and managing data, reduces administrative tasks, and ensures data accuracy and compliance. With the help of the Forms module, you can streamline the employee form data collection process, enhance employee experience, and maintain accurate and secure employee documentation.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Calendar/Calendar.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Calender.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Integrate with Outlook and Gmail',
        sectionContent:"With the capability to integrate with Outlook and Gmail, the WebHR calendar keeps your schedules aligned across platforms. This allows for all highlights and updates to be visible on your preferred platforms. Also, you can personalize calendar access in WebHR, tailoring visibility to suit your organizational structure whether by department or team.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/calendar/calendar_illustration01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Company-wide Events and Meetings',
        sectionContent:"The Calendar module of WebHR facilitates you to do the planning and coordination of company-wide events and meetings. You or your HR professionals can create events and meetings. This ensures that employees know important company events, such as town hall meetings, training sessions, team-building activities, etc.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/calendar/calendar_illustration02.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Planning Upcoming Events',
        sectionContent:"Planning upcoming events is a breeze with our calendar module. Simply input your event details, and it will appear on your calendar. This visual representation allows you to manage your schedule effectively, ensuring there are no conflicts or overlaps. Furthermore, you can monitor employee meeting records, providing a clear insight into each employee's meeting schedule. Say goodbye to scheduling chaos and embrace the ease of WebHR's calendar module.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/calendar/calendar_illustration03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'WebHR provides Multiple Calendar Views',
        sectionContent:"WebHR calendar module allows you to see multiple calendar views such as organization calendar, team calendar, departments calendar, etc. The calendar module gives you the flexibility to switch between monthly, weekly, and daily views to visualize events and schedules in a way that suits you, this enhances the user experience and enables efficient planning and scheduling.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/calendar/calendar_illustration04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Seamless integration with Outlook, Gmail, and Hotmail calendars to keep everything organized',
            image:"https://cdn.webhr.co/Website/images/modules/calendar/key_features/01.svg"
          }, 
          {
            listItem:"Obtain an overarching view of everyone's activities in a single glance",
            image:"https://cdn.webhr.co/Website/images/modules/calendar/key_features/02.svg"
          },
          { 
           listItem: "Five distinct calendars for diversified scheduling",
           image:"https://cdn.webhr.co/Website/images/modules/calendar/key_features/03.svg"
          }, 
          {
            listItem:"Efficient filters for precise, custom information retrieval",
            image:"https://cdn.webhr.co/Website/images/modules/calendar/key_features/04.svg"
          }, 
          {
            listItem:"Multiple Calendar Views",
            image:"https://cdn.webhr.co/Website/images/modules/calendar/key_features/05.svg"
          }],
        isAttendenceEnd:true,
      },
    },
  },
  // {
  //   metaDescription: 'Easily Perform Background Checks on Existing and Potential Employees',
  //   title: ' Background Check',
  //   slug: 'background',
  //   subTitle: 'Easily Perform Background Checks on Existing and Potential Employees',
  //   img: 'https://cdn.webhr.co/images/Web/Modules/BackgroundCheck/BackgroundCheck.jpg',
  //   thumb: 'https://cdn.webhr.co/images/Web/Modules/Thumbs/BackgroundCheck.jpg',
  //   sections: {
  //     section1: {
  //       attributes: {
  //         bg: Colors.bgBlue,
  //         shadow: Colors.redShadow,
  //       },
  //       sectionHeading: 'Criminal and Credit Check Services Provided By',
  //       sectionImg1: 'https://cdn.webhr.co/images/Integrations/TransUnion2.png',
  //     },
  //   },
  // },
  {
    metaDescription: 'Create and Generate as Many HR Letters as Needed for Your Employees',
    title: ' HR Letters',
    slug: 'hrletters',
    subTitle: 'The HR Letter Module provides a platform for designing and distributing various types of HR letters within an organization, such as offer letters, promotion letters, or employee contracts. By facilitating the efficient creation and sharing of these crucial documents, our HR Letter Module significantly streamlines HR operations, reducing errors and enhancing the overall employee experience.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/HRLetters/HRLetters.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery//HR_Letters.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Create HR Letter Templates',
        sectionContent: "With the WebHR HR Letter Module, you can craft HR letter templates that reflect your organization's specific needs, from offer letters to employment contracts, to promotion letters. The module also allows for the inclusion of custom variables, enabling you to personalize each letter according to the specific employee. This customization aligns with your organization's values and enhances the individual employee's experience.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_letters/01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Automate Employee Data with Ease',
        sectionContent: "HR letter automatically populates the letter with relevant employee data such as employee name, address, job title, employee email address, etc. This eliminates manual data entry and reduces the risk of errors and inconsistencies between HR letters and employee data, with this the HR Letter are personalized and tailored for individual employees, which enhance the employee experience.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_letters/02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Streamline request and Approval Workflow',
        sectionContent: "Within the HR Letter Module, you can establish unique approval workflows for each HR letter template. This feature allows you to efficiently track letters sent to employees, ensuring a smooth and efficient approval process.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_letters/03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'HR Letter records information at your figure tips',
        sectionContent: "WebHR HR letter module offers a centralized repository for storing the HR letter records and documents. You can easily access and view the past letters, making it convenient for you to check the previous records. This eliminates the need for physical documentation storage and reduces the risk of misplacing or losing important HR letters.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_letters/04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Customizable HR Letter templates',
            image:"https://cdn.webhr.co/Website/images/modules/hr_letters/key_features/01.svg"
          },
          {
            listItem:'Inclusion of custom variables',
            image:"https://cdn.webhr.co/Website/images/modules/hr_letters/key_features/02.svg"
          },
          {
            listItem:'Automated integration of employee data',
            image:"https://cdn.webhr.co/Website/images/modules/hr_letters/key_features/03.svg"
          },
          {
            listItem:'Defined workflows and notifications',
            image:"https://cdn.webhr.co/Website/images/modules/hr_letters/key_features/04.svg"
          },
          {
            listItem:'HR letter record-keeping',
            image:"https://cdn.webhr.co/Website/images/modules/hr_letters/key_features/05.svg"
          },
          {
            listItem:'Comprehensive reporting and analytics',
            image:"https://cdn.webhr.co/Website/images/modules/hr_letters/key_features/06.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    }
  },
  {
    metaDescription: 'Manage & Track “On-The-Go” Employees Using Real Time Tracking & GPS Location',
    title: 'eTrack',
    slug: 'etrack',
    subTitle: 'Manage & Track “On-The-Go” Employees Using Real Time Tracking & GPS Location. WebHR eTrack module is very efficient for your company as it enhances workforce visibility, optimizes operational efficiency, and promotes employee safety within an organization by utilizing advanced technology such as GPS and geofencing to track and monitor employees’ real-time location.  ',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Timesheet/Timesheet.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/ETrack.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Keep yourself updated with Employee Location real-time Tracking.',
        sectionContent: "The Employee Location Tracking module provides real-time visibility into the whereabouts of employees. It utilizes GPS technology to accurately track and monitor employee locations, both in the office premises and in the field. HR professionals can view employee locations on a centralized dashboard, enabling better resource allocation, task assignment, and emergency response management.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/e_track/01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Get Notified when the Employee Enters or Exits the Defined Geolocation',
        sectionContent: "The eTrack module allows u to define virtual boundaries on specific locations us as a work zone, restricted areas, and customer locations. When an employee enters or exits the defined boundaries, the system will send notifications or alerts, this enhances the security measures for your employee as you can track in which location the employee has entered.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/e_track/02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Reporting and Analytics',
        sectionContent: "The eTrack module of WebHR offers reporting and analytics capabilities for you to generate reports on employee locations, travel distances, and productivity metrics. These insights facilitate data-driven decision-making and support resource planning and optimization.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/e_track/03.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Mobile employee management',
            image:"https://cdn.webhr.co/Website/images/modules/e_track/key_features/01.svg"
          },  
          {
            listItem:'Real-time tracking and GPS location',
            image:"https://cdn.webhr.co/Website/images/modules/e_track/key_features/02.svg"
          }, 
          {
            listItem:'Tracking reports Access',
            image:"https://cdn.webhr.co/Website/images/modules/e_track/key_features/03.svg"
          },
          {
            listItem:'Set notifications on specific locations',
            image:"https://cdn.webhr.co/Website/images/modules/e_track/key_features/04.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'A Central Platform for Managing and Tracking Your Company Visits and Visitors',
    title: 'Visitors',
    slug: 'visitors',
    subTitle: 'The visitor’s module is a central platform for managing and tracking your company visits and visitors. It eliminates all your paperwork by automating any HR forms or sign-in sheets that you need to use to track your visitor’s check-in and check-out; it simplifies and strengthens the visitor’s management process within the organization. The Visitor module helps you to efficiently handle visitor registration and access control and a seamless visitors experience.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/CoreHR/CoreHR.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Visitors.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'All Your Visitor’s Data in One Place',
        sectionContent: "WebHR visitor’s module provides you with a user-friendly interface for you to register visitors’ records, by adding the visitor’s personal information such as name, contact information, etc. Once registered they can check in and out from the kiosk. This streamlines the process and minimizes the manual paperwork, reduces wait time, and enhances the overall visitor experience.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Visitors/01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Visitor Analytics and Reporting',
        sectionContent: "The Visitors module provides analytics and reporting capabilities for you to generate reports on visitor lists, and visitors visit reports. These insights help you to analyze visitor patterns, optimize resource allocation, and make data-driven decisions to improve visitor management processes.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Visitors/02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Centralized Visits and Visitors’ Data',
            image:"https://cdn.webhr.co/Website/images/modules/visitors/key_features/01.svg"
          },  
          {
            listItem:'Easily track your visitors and visit trends',
            image:"https://cdn.webhr.co/Website/images/modules/visitors/key_features/02.svg"
          }, 
          {
            listItem:'Easily count your total number of visitors for any given day in case of an emergency evacuation   ',
            image:"https://cdn.webhr.co/Website/images/modules/visitors/key_features/03.svg"
          },
          {
            listItem:'Sign in and sign out trends and reports',
            image:"https://cdn.webhr.co/Website/images/modules/visitors/key_features/04.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'Your One-Stop Shop for Your Company Assets Management and Tracking',
    title: 'Assets',
    slug: 'assets',
    subTitle: 'Your One-Stop Shop for Your Company Assets Management and Tracking, the assets module enables you to manage your physical assets such as equipment, tools, and technology devices. This makes it easy for you to track, allocate and maintain organization assets, additionally, it streamlines asset management processes and ensures optimal utilization of resources. Furthermore, you can also manage the lost and misplaced assets within the organization which helps you to track lost assets and streamline the recovery process and ensure effective management of organization resources.',
    // img: 'https://cdn.webhr.co/images/Web/Modules/Trainings/Trainings.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Assets.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Stay Informed about your Organization’s Asset Inventory',
        sectionContent: "The assets module allows you to maintain a comprehensive inventory of the organizational assets that includes the details such as asset type, serial number, Asset amount, vendor name, asset quantity, etc. This information helps you to easily track the visibility of all assets, furthermore, this minimizes the risk of loss, theft, or misplaced.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/assets/assets_illustrations01.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Visitor Analytics and Reporting',
        sectionContent: "The Visitors module provides analytics and reporting capabilities for you to generate reports on visitor lists, and visitors visit reports. These insights help you to analyze visitor patterns, optimize resource allocation, and make data-driven decisions to improve visitor management processes.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/assets/assets_illustrations02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Manage Asset Check-in and Check-out Processes',
        sectionContent: "The assets module of WebHR helps you to manage the asset check-out and check-in process, Employees can check out the assets that they require and once the request is made the records will be for your approval from the respective authority. Once the asset is checked out the system automatically updates the asset’s quantity status",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/assets/assets_illustrations03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'WebHR Makes It Easy for You to Keep Track of Lost Assets',
        sectionContent: "The assets lost and found module will your employee to report lost assets within the system, at the time of reporting the lost assets they can mention the detail of the asset such as asset description, date of loss, any relevant notes, add a picture/ attachment, etc. furthermore it allows you to record and update the status of recovered assets, such as whether it has been returned to the owner. The assets module ensures transparency and accountability in the asset’s recovery process.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/assets/assets_illustrations04.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Centralized Visits and Visitors’ Data',
            image:"https://cdn.webhr.co/Website/images/modules/assets/key_features/01.svg"
          },  
          {
            listItem:'Easily track your visitors and visit trends',
            image:"https://cdn.webhr.co/Website/images/modules/assets/key_features/02.svg"
          }, 
          {
            listItem:'Easily count your total number of visitors for any given day in case of an emergency evacuation   ',
            image:"https://cdn.webhr.co/Website/images/modules/assets/key_features/03.svg"
          },
          {
            listItem:'Sign in and sign out trends and reports',
            image:"https://cdn.webhr.co/Website/images/modules/assets/key_features/04.svg"
          },
          {
            listItem:'Sign in and sign out trends and reports',
            image:"https://cdn.webhr.co/Website/images/modules/assets/key_features/05.svg"
          },
          {
            listItem:'Sign in and sign out trends and reports',
            image:"https://cdn.webhr.co/Website/images/modules/assets/key_features/06.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'Employees module streamlines HR tasks, centralizes employee data for lifecycle management, and fosters strategic initiatives and a positive work culture',
    title: 'Employee',
    slug: 'employee',
    subTitle: "Managing employee data and tasks has never been easy, in WebHR you can manage all employee components such as focusing on employee data and streamlining HR operations related to employee management, from the employee module you can get the centralized database through which you can store and access the comprehensive employee information. This makes it easy for you to efficiently manage the entire employee lifecycle. By centralizing employee information and automating HR tasks, the Employees module of WebHR empowers you to focus on strategic initiatives, employee development, and creating a positive work environment.",
    // img: 'https://cdn.webhr.co/images/Web/Modules/Recruitment/Recruitment.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Employees.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Seamlessly Manage Employee Profiles and Data",
        sectionContent: "The Employees module provides a centralized repository for storing and managing employee profiles. You can easily access and update employee information, including personal details, contact information, and more. This reduces administrative effort by eliminating the need for manual record-keeping also it ensures data accuracy.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/employees/employee_illustration_01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Employee Onboarding and Offboarding Processes',
        sectionContent:
          "The Employees module facilitates streamlined onboarding and offboarding processes. This makes it easy for you to create standardized onboarding checklists, automate the provisioning of employee accounts and access to company resources, and track the progress of new hires. Similarly, when an employee leaves the organization, you or HR teams can efficiently manage offboarding tasks, such as revoking access privileges, conducting exit interviews, and processing final payments.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/employees/employee_illustration_02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Multi-user Role Base System',
        sectionContent: "You can define the user roles and permission within WebHR, this ensures that different users have appropriate access levels based on their roles and responsibilities. You being the system admin can assign specific permissions to HR professionals, managers, and employees, ensuring data security and maintaining confidentiality.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/employees/employee_illustration_03.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Managing Employee Travel and Expenses',
        sectionContent:
          "Managing employee travel and travel expenses can be tough, with WebHR you can streamline the management of employee travel and related expenses. It simplifies the process of requesting, approving, and tracking travel arrangements while ensuring compliance with organizational policies.  Employees can submit travel requests through the HR software, specifying travel dates, destinations, and the purpose of the trip. Managers can review and approve these requests within the system, ensuring a streamlined and standardized process for managing travel arrangements.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/employees/employee_illustration_04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Defining Employee Role and Job Descriptions',
        sectionContent:
          "WebHR allows you to create and define job roles within the system. This includes providing detailed job descriptions, specifying required skills and qualifications, and outlining responsibilities and reporting relationships. By clearly defining job roles, organizations can set expectations and ensure employees understand their roles and responsibilities.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/employees/employee_illustration_05.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Reporting and Analytics',
        sectionContent: "Employee module reports are readily available. You can generate them from the report’s module, these reports provide robust reporting and analytics capabilities. HR professionals can generate reports on employee demographics, turnover rates, Travel records, and more. These insights help identify trends, make data-driven decisions, and measure the effectiveness of HR strategies and initiatives.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/employees/employee_illustration_06.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section7: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Employee Profile Management',
            image:"https://cdn.webhr.co/Website/images/modules/employees/key_features/01.svg"
          },  
          {
            listItem:'Onboarding and Offboarding',
            image:"https://cdn.webhr.co/Website/images/modules/employees/key_features/02.svg"
          }, 
          {
            listItem:'Role-Based Access Control ',
            image:"https://cdn.webhr.co/Website/images/modules/employees/key_features/03.svg"
          },
          {
            listItem:'Approvals and Notifications',
            image:"https://cdn.webhr.co/Website/images/modules/employees/key_features/04.svg"
          },
          {
            listItem:'Employee Document Management',
            image:"https://cdn.webhr.co/Website/images/modules/employees/key_features/05.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: "Organization Module provides a centralized platform for HR professionals to configure and customize the organization's structure, policies, and settings",
    title: 'Organization',
    slug: 'organization',
    subTitle: "WebHR makes it easy for you to define the organizational structure in the simplest way. With WebHR you can easily create a company structure in the system and do the organization-wide setting which will be applicable for all employees, you can add company policies, set reminders, notifications, and many more. The organization module is an essential module of WebHR that allows you to manage the organization’s information. It provides a centralized platform for HR professionals to configure and customize various aspects of the organization's structure, policies and settings.",
    // img: 'https://cdn.webhr.co/images/Web/Modules/Recruitment/Recruitment.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Organization.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Seamlessly Manage the Organizational Structure",
        sectionContent: "The organization module allows you to define and manage the organization's structure, including stations, departments, divisions, and teams. This gives you clear visibility of the organizational hierarchy and facilitates effective communication and decision-making across the organization. Additionally, the module allows for the management of multiple locations or branches, ensuring accurate tracking of employee data based on their work location.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Organization/Organization01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'WebHR Notification Helps You Stay Updated',
        sectionContent: "WebHR software gives you the functionality of notification settings within the Organization module. You can customize the notification you want to get notified of, such as visa expiry, employee contract end date, etc.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Organization/Organization02.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Stay Updated Regarding the Company Policies and Handbook',
        sectionContent:
          "You can easily create and maintain company policies, procedures, and employee handbooks within the organization module. This feature helps ensure consistent communication of company guidelines and provides employees with easy access to important information regarding company rules, benefits, code of conduct, and other company policies.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Organization/Organization03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Easily Notify the Employee of the Company Announcement',
        sectionContent:
          "The organization module allows you to define and manage the organization's structure, including stations, departments, divisions, and teams. This gives you clear visibility of the organizational hierarchy and facilitates effective communication and decision-making across the organization. Additionally, the module allows for the management of multiple locations or branches, ensuring accurate tracking of employee data based on their work location.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Organization/Organization04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Configuring the System Based on System Administration',
        sectionContent: "The system settings allow administrators to configure the HR software according to the organization's unique requirements, ensuring data security, customization, and system efficiency. These modules contribute to efficient HR management and support the organization's overall goals and objectives.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Organization/Organization05.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section7: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Audit Trail and Data Privacy',
        sectionContent: "Tracking employee actions is not an easy task, through WebHR system logs you can audit the trail of each action performed by an employee, with this the company can keep track of the activity performed within the system. You can track the employee’s activities as well as set the security policy for the system from the organization module you can configure settings to track and log system activities, user actions, and data modifications. This helps maintain data integrity, supports compliance requirements, and provides transparency in system usage.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Organization/Organization06.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section8: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Organizational Structure',
            image:"https://cdn.webhr.co/Website/images/modules/organization/key_features/01.svg"
          },  
          {
            listItem:'Audit Trail and Data Privacy',
            image:"https://cdn.webhr.co/Website/images/modules/organization/key_features/02.svg"
          }, 
          {
            listItem:'Company Policies and Handbook',
            image:"https://cdn.webhr.co/Website/images/modules/organization/key_features/03.svg"
          },
          {
            listItem:'Notifications and reminders',
            image:"https://cdn.webhr.co/Website/images/modules/organization/key_features/04.svg"
          },
          {
            listItem:'Company Announcements',
            image:"https://cdn.webhr.co/Website/images/modules/organization/key_features/05.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: "Discover the simplicity of capturing your employees' details with our one-stop Employee Directory.",
    title: 'Directory',
    slug: 'directory',
    subTitle: "Discover the simplicity of capturing your employees' details with our one-stop Employee Directory. This feature, meticulously designed around the needs of your organization, allows you to easily access both a brief and comprehensive profile of your employees all from one convenient screen. No need to navigate through multiple modules or submodules for crucial information; everything you need is just a click away.",
    // img: 'https://cdn.webhr.co/images/Web/Modules/Recruitment/Recruitment.jpg',
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Directory.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Importance of confidentiality",
        sectionContent: "The module provides you with ease to see detailed profiles for each employee. Employee profiles typically include information such as job title, department, skills, certifications, location, contact details, and work history. This gives you a comprehensive overview of each employee, facilitating effective collaboration, team formation, and communication within the organization.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/directory/directory_illustration01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Centralized Employee Database',
        sectionContent: "The Directory module of WebHR acts as a centralized repository for all employee-related information. It compresses data such as employee names, job titles, departments, contact details, and other relevant information into a single, easily accessible location. This eliminates the need for multiple spreadsheets or manual records, ensuring data accuracy and consistency.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/directory/directory_illustration02.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Quick access to Employee Profiles and Details',
        sectionContent:
          "Furthermore, we understand the importance of confidentiality in a professional setting. With that in mind, we've designed the access to be flexible, giving you the control to limit what information is visible to other employees Reimagine the way you interact with employee data, streamlined for optimal user experience and productivity.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/directory/directory_illustration03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgRed,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Quickly Connect with the colleagues',
        sectionContent:
          "The directory module gives you an option to search which allows you to find and connect with the employees quickly. You can search for an employee based on various criteria such as employee name, username, etc. The search functionality ensures that employees can easily locate and connect with the right individuals within the organization.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/directory/directory_illustration04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgGrey,
          shadow: Colors.redShadow,
          align: 'left',
        },
        sectionHeading: 'Mobile Accessibility',
        sectionContent: "You can access the employee details via phone, this allows you to access employee information on the go. Mobile accessibility enables employees to quickly find contact details, check organizational structure, and connect with their colleagues, even when they are outside the office. It promotes flexibility, enhances communication, and supports remote work environments.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/directory/directory_illustration05.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Organizational Structure',
            image:"https://cdn.webhr.co/Website/images/modules/directory/key_features/01.svg"
          },  
          {
            listItem:'Audit Trail and Data Privacy',
            image:"https://cdn.webhr.co/Website/images/modules/directory/key_features/02.svg"
          }, 
          {
            listItem:'Company Policies and Handbook',
            image:"https://cdn.webhr.co/Website/images/modules/directory/key_features/03.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: "With the files module, you can easily organize employees' and organizations' files into structured folders, providing an efficient approach to managing your documents",
    title: 'Files',
    slug: 'files',
    subTitle: "WebHR offers an effective solution for managing your company's documents via its robust cloud server. With our system, you can easily organize your files into structured folders, providing an efficient approach to managing your documents. This not only saves time but also boosts productivity. Moreover, you can customize access to these folders based on specific employees, divisions, or even the entire company, ensuring your documents' security and accessibility.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Files.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "All Your Organizational and Employee Documents in One Place",
        sectionContent: "WebHR files module makes it easy for you to upload organizational/ employee documents within the system. This module gives you control functionally, allowing you to track and manage different formats of documents. Additionally, WebHR provides you with a secure digital storage space, this eliminates the need for physical filing capabilities, and it reduces the risk of documents being lost or damaged. You can create different folders or sub-folders to categorize and organize documents.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Files/01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Define Access Control and Security",
        sectionContent: "In the WebHR files module, you don’t have to worry about the data security of sensitive documents as you can define the folder permission access to authorized personnel. So, it is within your control whom you want to give access to the folders, and based on the access they can see the documents. The files module allows you to maintain strict control over confidential documents and ensure that confidential information remains protected.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Files/02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Easily lets you search Documents Search and Retrieval",
        sectionContent: "The files module gives you powerful search capabilities that enable you to search the relevant documents. You can search for the documents based on the document name, keywords, etc. This option eliminates the need for you to manually search individual files or navigate complex folder structures. This option helps you to save time and improve overall efficiency.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Files/03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Robust Cloud Server',
            image:"https://cdn.webhr.co/Website/images/modules/files/key_features/1.svg"
          },
          {
            listItem:'Efficient Organization',
            image:"https://cdn.webhr.co/Website/images/modules/files/key_features/2.svg"
          },
          {
            listItem:'Customizable Access',
            image:"https://cdn.webhr.co/Website/images/modules/files/key_features/3.svg"
          },
          {
            listItem:'Time-saving',
            image:"https://cdn.webhr.co/Website/images/modules/files/key_features/4.svg"
          },
          {
            listItem:'Secure',
            image:"https://cdn.webhr.co/Website/images/modules/files/key_features/5.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'WebHR dashboard module enables organizations to foster employee engagement, enhance collaboration, and promote a positive workplace culture',
    title: 'Dashboard',
    slug: 'dashboard',
    subTitle: "WebHR dashboard module is a powerful component that enables organizations to foster employee engagement, enhance collaboration, and promote a positive workplace culture. It provides a social platform that allows you to connect, engage and share knowledge with your employees. WebHR provides an easy way to perform an action within a few clicks with the help of multiple module widgets sitting on the dashboard.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Dashboards.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Social Platform through which the Employees can Engage and Communicate",
        sectionContent: "WebHR Dashboard module facilitates employee engagement by providing a digital space for employees to interact and share ideas. It includes features such as news feeds, discussion forums, and messaging functionalities that enable real-time communication and foster a sense of community. Employees can stay updated on company news, share accomplishments, and collaborate across teams, enhancing overall employee engagement. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Dashboard/01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Appreciating employees enhances employees’ productivity.",
        sectionContent: "Recognizing employee achievements and giving them the badge is essential for motivating and retaining top-talent employees. The Dashboard module includes features that allow you to publicly recognize the accomplishments and contributions of employees in front of their peers. Employees can give shout-outs, likes, or badges, wishing them a birthday or work anniversary announcement that creates a positive and supportive work environment. This boosts employee morale, encourages high performance, and strengthens employee relationships. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Dashboard/02.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "From where can I get to know about the Company Structure?",
        sectionContent: "The reporting structure of your company is just a click away in a system that you can access through Organogram. It helps you to create a deeper understanding of the company hierarchy structure, and it will be easy for you to understand which employee is directly/ indirectly reporting to whom. You can also set the Organogram in different user-friendly layouts. Organogram (sometimes referred to as the organization chart, org chart, or organogram) is a great way to visualize the employee's tree based on the employee's reporting line.  Organogram on the dashboard shows graphically the relation of one employee to another, within the organization. Organograms are valuable in that they enable you to visualize a complete organization, by means of the picture it presents.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Dashboard/03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Analytics and Insights",
        sectionContent: "The Social HR Dashboard module provides analytics and insights on Company and employee information which you can get from our HR Data and HR dashboard, which gives you the information through different pie charts and bar graphs. These insights help HR professionals understand employee needs, measure the effectiveness of the employee, and identify areas for improvement. By leveraging analytics, organizations can continuously enhance their HR strategies and drive positive employee experiences. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Dashboard/04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Communication gets Easy when using WebHR",
        sectionContent: "Employees can easily communicate with each other through messaging and chat functionalities that allow employees to have real-time conversations, share files, and collaborate on projects. Employees can engage in one-on-one or group conversations, facilitating seamless communication and quick information exchange. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Dashboard/05.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Updated News Feeds and Activity Streams within the company ",
        sectionContent: "The dashboard module provides a centralized news feed or activity stream that displays updates, announcements, and relevant information. Employees can stay informed about company news, policy changes, upcoming events, and other important updates. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Dashboard/06.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section7: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Updated News Feeds and Activity Streams',
            image:"https://cdn.webhr.co/Website/images/modules/dashboard/key_features/01.svg"
          },
          {
            listItem:'Analytics and Insights',
            image:"https://cdn.webhr.co/Website/images/modules/dashboard/key_features/02.svg"
          },
          {
            listItem:'Document Sharing',
            image:"https://cdn.webhr.co/Website/images/modules/dashboard/key_features/03.svg"
          },
          {
            listItem:'Rewards and recognition',
            image:"https://cdn.webhr.co/Website/images/modules/dashboard/key_features/04.svg"
          },
          {
            listItem:'Messaging and Chat',
            image:"https://cdn.webhr.co/Website/images/modules/dashboard/key_features/05.svg"
          },
        ],
        isAttendenceEnd: true,
        bottomContent:true,
        bottomContentData:{
          heading:"Data Security",
          content:"We prioritize data security and privacy by implementing robust security measures and complying with data protection regulations. We know Employee data is sensitive, and we ensure the security and confidentiality of sensitive employee information as we take proper security measures to keep it safe. WebHR uses General Data Protection Regulation (GDPR), TLS 1.2, and TLS 1.3 for top-notch security, and multiple data backups are taken daily at a remote location as it is essential for us to safeguard employee privacy."
        }
      },
    },
  },
  {
    metaDescription: 'Timesheet module allows your employees to record their working hours, leaves, and tasks, this helps you to monitor and manage employee time data',
    title: 'Timesheet',
    slug: 'timesheet',
    subTitle: "The timesheet module of WebHR is the most advanced and easiest, focusing on efficient time tracking, leave quota, and leave management. It allows your employees to record their working hours, leaves, and tasks, this helps you to monitor and manage employee time data. This module helps you manage employee time, optimize resource allocation, and drive project success and overall workforce management.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Timesheet.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Easy to Track Working Hours",
        sectionContent: "Managing employee working hours can be tricky, WebHR timesheet module enables employees to add their working hours, and they can also enter their start and end times, breaks, and activities performed during the day which makes it easy for you to track the time, this module captures the real-time information, facilitating accurate payroll calculations and keeping a track on time recoding.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Timesheet/01.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Integration with Payroll",
        sectionContent: "The Timesheet module seamlessly integrates with payroll. This eliminates the need for manual data entry and reduces the risk of errors. Approved attendance, employee hours and leave records can be directly linked to payroll calculations, ensuring accurate and timely salary payments.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Timesheet/02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Seamlessly manage the Employee Leave Encashment and Carry-forward",
        sectionContent: "As per your organizational policies, if you give your employees an option to en-cash their unused leaves or carry them forward to the next year. The timesheet module allows you to manage these processes, calculate leave encashment amounts, and track carried-forward leaves, this provides flexibility for employees and ensures accurate leave-related financial transactions.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Timesheet/03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Easy to Track Employee’s Overtime and Leave",
        sectionContent: "The timesheet module makes it easy for you to track overtime hours and leave taken by the employees. It automatically calculates overtime based on defined rules and policies, ensuring accurate overtime payments. Additionally, it helps you to monitor and manage employee leave balances, ensuring compliance with company policies and labor regulations.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Timesheet/04.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Approval Workflows",
        sectionContent: "The Timesheet module streamlines the approval process for recorded time entries, leaves records, etc. Supervisors or managers can review and approve timesheets within the software, ensuring accuracy and preventing discrepancies. The timesheet module helps to eliminate manual paperwork, reduces errors, and saves time for both employees and supervisors.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Timesheet/05.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Reporting and Analytics",
        sectionContent: "The timesheet module of WebHR provides comprehensive reporting and analytics capabilities. HR professionals can generate reports on employee hours, leaves, overtime, and worksheets. These insights help identify trends, analyze resource utilization, and make data-driven decisions for optimizing workforce efficiency.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Timesheet/06.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section7: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Real-time Information',
            image:"https://cdn.webhr.co/Website/images/modules/timesheet/key_features/01.svg"
          },
          {
            listItem:'Overtime and leave tracking.',
            image:"https://cdn.webhr.co/Website/images/modules/timesheet/key_features/02.svg"
          },
          {
            listItem:'Approvals Workflows',
            image:"https://cdn.webhr.co/Website/images/modules/timesheet/key_features/03.svg"
          },
          {
            listItem:'Leave balance and approval.',
            image:"https://cdn.webhr.co/Website/images/modules/timesheet/key_features/04.svg"
          },
          {
            listItem:'Manage employee work shifts.',
            image:"https://cdn.webhr.co/Website/images/modules/timesheet/key_features/05.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: 'Expiration Module serves as a centralized hub to ensure document validity is kept in check and that relevant personnel are notified promptly regarding any impending document expiry',
    title: 'Expiration',
    slug: "expiration",
    subTitle: "Our WebHRs’ expiration module dedicated to managing document expiry allows for a seamless way to keep track of, and manage, the lifecycle of your organization's crucial documents. This system serves as a centralized hub to ensure document validity is kept in check and that relevant personnel are notified promptly regarding any impending document expiry.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Expiration.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Tailored Expiry Reminders Aligned with Your Organization's Needs",
        sectionContent: "The module enables you to customize reminder settings to align with your organization's unique requirements. For each document, you can set three types of reminders: a pre-due date reminder, a critical date reminder, and a post-expiry reminder. This empowers you to define the timing and frequency of notifications, ensuring employees and other concerned parties are forewarned well in advance of any document expiring.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expiration/01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Unified Document Repository",
        sectionContent: "WebHR expiration management module functions as a consolidated depot for storing and handling a diverse array of document types, including certifications, contracts, licenses, agreements, and permits. It allows you to systematically upload and organize your organization's documents, assigning each one an expiry date.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expiration/02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Effortless Expiry Date Monitoring",
        sectionContent: "The expiration module has been designed to facilitate the hassle-free setting of expiry dates for each document. This ensures validity is constantly monitored. Based on the dates you input, the system keeps track of when each document is due to expire, sending automated notifications to key parties such as HR administrators, managers, or the employees themselves, alerting them of upcoming document expirations.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expiration/03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Easy to Track Expiration Date",
        sectionContent: "WebHR expiration module makes it easy for you to set expiration dates for each document, ensuring that they are monitored for validity. Based on the dates that you defined the system tracks the expiration dates and sends automated notifications to the relevant authorities, such as HR administrators, managers, or employees to alert them about upcoming document expirations.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expiration/04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Comprehensive document management for your organization.',
            image:"https://cdn.webhr.co/Website/images/modules/Expiration/KeyFeatures/01.svg"
          },  
          {
            listItem:'Efficient tracking of document expiry dates.',
            image:"https://cdn.webhr.co/Website/images/modules/Expiration/KeyFeatures/02.svg"
          }, 
          {
            listItem:'Automated notifications.',
            image:"https://cdn.webhr.co/Website/images/modules/Expiration/KeyFeatures/03.svg"
          },
          {
            listItem:'Customizable expiry reminders.',
            image:"https://cdn.webhr.co/Website/images/modules/Expiration/KeyFeatures/04.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    },
  },
  {
    metaDescription: "WebHR wellness module offers a robust toolset to vigilantly monitor employees'; well-being, particularly during challenging times",
    title: 'Wellness',
    slug: "wellness",
    subTitle: "A successful organization's cornerstone lies in prioritizing its employees' health and safety. The WebHR wellness module offers a robust toolset to vigilantly monitor employees'; well-being, particularly during challenging times such as the ongoing COVID-19 pandemic. By investing in our employees'; well-being, we aim to foster a more satisfied workforce and propel the organization toward greater heights of success.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Wellness.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Holistic View via Wellness Dashboard",
        sectionContent: "Our wellness module's dashboard provides a detailed overview of COVID-19-related data within the organization. Information, such as the number of employees testing positive or negative for COVID-19, vaccination rates, and more, are easily accessible. This vital data enables you to comprehend the overall health landscape of your employees, allowing you to make informed decisions for maintaining a secure work environment.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Wellness/01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Effortless Employee Vaccination Status Tracking",
        sectionContent: "With the increasing significance of vaccinations, the WebHR wellness module enables you to monitor the vaccination status of employees effortlessly. You can input important vaccine-related data such as the vaccine name, status, date, and other relevant details. This facilitates a comprehensive overview of vaccination statuses within your organization.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Wellness/02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Ensuring Health Transparency",
        sectionContent: "WebHR's wellness module simplifies the health tracking of your employees. By distributing a health screening form, employees can share their health status, travel history, and recent contact information. This transparency aids in identifying potential risks within the workforce, enabling you to take appropriate measures to safeguard your employees and curb virus spread. If an employee tests positive for COVID-19, the system ensures prompt notification.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Wellness/03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "WebHR Helps you to Track Potential Infected Employee COVID Exposure",
        sectionContent: "Leveraging the power of the contact tracing submodule, our wellness module helps you trace potential COVID-19 exposure within your organization. By maintaining records of individuals who may have interacted with an infected employee, you can effectively notify affected employees, helping minimize the virus spread.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Wellness/04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Employee Vaccination Tracking',
            image:"https://cdn.webhr.co/Website/images/modules/wellness/key_features/1.svg"
          },  
          {
            listItem:'Timely Notifications and Alerts',
            image:"https://cdn.webhr.co/Website/images/modules/wellness/key_features/2.svg"
          }, 
          {
            listItem:'Contact Tracing',
            image:"https://cdn.webhr.co/Website/images/modules/wellness/key_features/3.svg"
          },
          {
            listItem:'Wellness Report Data',
            image:"https://cdn.webhr.co/Website/images/modules/wellness/key_features/4.svg"
          },
        ],
        isAttendenceEnd: true,
      
      },
    }
  },
  {
    metaDescription: 'HR Budget module gives you a centralized platform for you to track and analyze your budget, better financial control, and decision-making',
    title: 'HR Budget',
    slug: "hrbudget",
    subTitle: "With WebHR’s HR Budget module, you can streamline and optimize the organization’s budget planning and management processes. This module gives you a centralized platform for you to track and analyze your budget, better financial control, and decision-making. HR Budget module makes it easy for you to plan the employee hiring budget, travel, and event budget monitoring, cost comparison, etc. which helps you to ensure better financial control and cost efficiency.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery//HRBudget.webp',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "WebHR Makes it Easy for you to Track and Control Expenses",
        sectionContent: "We know that tracking the company budget is difficult, but in the HR budget module, you can track actual expenses against budgeted amounts in real time. This allows you to have better control over HR spending and identify cost-saving opportunities, which helps you to make informed decisions to optimize resource allocation. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_budget/illustration_01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Allocating the Budget",
        sectionContent: "You can create a budget for various HR functions such as recruitment, travel, and events in the HR Budget module. Furthermore, based on the budget defined the system will not let you add a travel or events record if it exceeds the budgeted amount.  These budgets can be allocated to specific cost categories or initiatives, to ensure a structured approach to financial planning. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_budget/illustration_02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "HR Budget Workflows",
        sectionContent: "submodule to streamline the budget approval process. You can define approval levels; this allows you to ensure that the budgets are reviewed and approved by the relevant authorities. This promotes transparency and accountability in budget management within the company. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_budget/illustration_03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Integration with Travel and Event Management Systems",
        sectionContent: "HR Budget module is linked with travel and event management, which makes it easy to add the event and travel record based on the budget defined, if the amount exceeds the limit the system will let not let anyone add the record to the system against that budget. This helps you t",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_budget/illustration_04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "HR Budget Reporting and Analysis",
        sectionContent: "The HR Budget module allows you to generate multiple reports such as budget reports, open positions reports, planning reports, hiring budget reports, travel budget reports, etc. these reports help you to visualize the highlighted areas over the spending, utilize the budget, evaluate the effectiveness of HR initiatives and optimizing budget allocation.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/hr_budget/illustration_05.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'HR Budget Planning and Allocation',
            image:"https://cdn.webhr.co/Website/images/modules/hr_budget/key_features/1.svg"
          },  
          {
            listItem:'Budget Monitoring and Control',
            image:"https://cdn.webhr.co/Website/images/modules/hr_budget/key_features/2.svg"
          }, 
          {
            listItem:'Hiring budget',
            image:"https://cdn.webhr.co/Website/images/modules/hr_budget/key_features/3.svg"
          },
          {
            listItem:'Event budget',
            image:"https://cdn.webhr.co/Website/images/modules/hr_budget/key_features/4.svg"
          },
          {
            listItem:'Travel budget',
            image:"https://cdn.webhr.co/Website/images/modules/hr_budget/key_features/5.svg"
          },
          {
            listItem:'Approval Workflow ',
            image:"https://cdn.webhr.co/Website/images/modules/hr_budget/key_features/6.svg"
          },
          {
            listItem:'HR Budget Reporting and Analysis',
            image:"https://cdn.webhr.co/Website/images/modules/hr_budget/key_features/7.svg"
          },
        ],
        isAttendenceEnd: true,
      
      },
    }
  },
  {
    metaDescription: "Streamline your expense management with WebHR's Expense Module. Efficiently track, manage, and report employee expenses with ease",
    title: 'Expense',
    slug: "expense",
    subTitle: "WebHR's Expense module presents a comprehensive solution to manage and monitor all employee expenses within your organization. It enables your employees to submit expense claims, streamlines the approval process, and ensures meticulous tracking of expenditures. With the ability to apply complex expense calculations, the module ensures accuracy and consistency across all expense-related activities, enhancing expense management efficiency. ",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Expense.png',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Customizable Expense Form Templates",
        sectionContent: "WebHR's Expense module empowers you to design and customize expense forms to meet your organization's unique needs. Incorporate conditional logic and formulas tailored to your company's policies, facilitating complex calculations without needing advanced programming skills. This user-friendly interface enhances productivity and user experience.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expense/Expense01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "WebHR Makes it Easy for The Employee to Fill Out Expense Forms",
        sectionContent: "Employees can fill out the expense form within the system at ease, the forms are designed to be easy to navigate or fill, which ensures that employees can quickly and accurately enter their expense information. Guided instructions can be added to each form template, further facilitating the submission process and improving user experience.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expense/Expense02.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Attach Supporting Documents with Ease",
        sectionContent: "Supporting documents such as digital copies, relevant records, or invoices can be attached during the expense form completion process, abolishing the need for manual document handling and ensuring all necessary paperwork is readily available for review and auditing.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expense/Expense03.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Resume and Complete Expense Forms Later",
        sectionContent: "WebHR's Expense module provides the convenience of saving progress and completing expense forms later. This feature benefits employees who may need additional time to gather information or seek approvals, adding flexibility to the expense submission process. Upon submission, the system automatically routes the form to the designated approvers.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expense/Expense04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Expense Analytics and Reporting",
        sectionContent: "The Expense module provides detailed reports on expense form submissions, categories, merchants, and other pertinent data. These insights offer visibility into expense trends, help identify potential areas for cost savings, and enable data-driven decision-making.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Expense/Expense05.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Customizable Expense Templates',
            image:"https://cdn.webhr.co/Website/images/modules/Expense/Key_features/1.svg"
          },
          {
            listItem:'Logical Formulas for Expense Calculations',
            image:"https://cdn.webhr.co/Website/images/modules/Expense/Key_features/2.svg"
          },
          {
            listItem:'Centralized Expense Data',
            image:"https://cdn.webhr.co/Website/images/modules/Expense/Key_features/3.svg"
          },
          {
            listItem:'Self-Serve Expense Form Completion',
            image:"https://cdn.webhr.co/Website/images/modules/Expense/Key_features/4.svg"
          },
          {
            listItem:'Notification and Approval System',
            image:"https://cdn.webhr.co/Website/images/modules/Expense/Key_features/5.svg"
          },
          {
            listItem:'Detailed Expense Reports',
            image:"https://cdn.webhr.co/Website/images/modules/Expense/Key_features/6.svg"
          },
        ],
        isAttendenceEnd: true,
      
      },
    }
  },
  {
    metaDescription: 'Explore our Help Desk module for efficient ticket management, streamlined categorization, prioritization, and real-time progress tracking',
    title: 'Help Desk',
    slug: "helpdesk",
    subTitle: "The help desk module is key to managing requisitions and backend interdepartmental working within the company while maintaining the status and relevant access levels of all individuals for each raised query/ ticket. This module enables efficient management of employee inquiries and support requests. The Helpdesk module works as a centralized platform for employees to seek assistance and access relevant information, this enhances transparency, promotes collaboration, and improves response time.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery//HelpDesk.png',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Any inquiries? Don’t worry, you can raise the query by creating the ticket.",
        sectionContent: "Your employees can create a ticket for their inquiries, issues, or support requests from the help desk module. At the time of creating the ticket employee can mention the relevant information such as the ticket category. Priority level, and any supporting document or attachment. All the necessary information is captured through this module, and it facilitates efficient ticket handling.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/HelpDesk/HelpDesk01.png',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Seamlessly Prioritize and Categorize the Tickets",
        sectionContent: "WebHR makes it easy for you to streamline ticket management by categorizing and prioritizing tickets based on urgency or custom criteria. You can create different categories for the tickets such as Payroll support, HR, IT, or general inquiries while defining the employee’s name who is responsible for the respective ticket category. Additionally, you can prioritize the tickets based on urgency, this makes it easy for you to allocate resources effectively and address critical issues promptly.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/HelpDesk/HelpDesk02.png',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "The right person to handle the tickets.",
        sectionContent: "WebHR helpdesk module automates the ticket assignment and routing to the appropriate HR personnel or department, by defining each category authorized person, by doing this the tickets are assigned to the right individuals or team who are responsible for handling specific types of issues. This reduces manual effort, minimizes delays, and ensures that tickets are efficiently directed to the right person.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/HelpDesk/HelpDesk03.png',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Keep yourself updated by Ticket Tracking and Progress Monitoring",
        sectionContent: "The helpdesk module allows you to track and monitor the progress of the tickets in real-time, such as you can view the status of each ticket, the current stage of the ticket, who is the authorized person and any updates or comments, this makes it easy for you that critical or complex issues are promptly escalated to higher levels of support or management.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/HelpDesk/HelpDesk04.png',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Ticket management',
            image:"https://cdn.webhr.co/Website/images/modules/HelpDesk/Key_features/1.svg"
          },  
          {
            listItem:'Ticket Categorization and Prioritization',
            image:"https://cdn.webhr.co/Website/images/modules/HelpDesk/Key_features/2.svg"
          }, 
          {
            listItem:'Automate Routing Tickets',
            image:"https://cdn.webhr.co/Website/images/modules/HelpDesk/Key_features/3.svg"
          },
          {
            listItem:'Ticket Tracking and Progress Monitoring',
            image:"https://cdn.webhr.co/Website/images/modules/HelpDesk/Key_features/4.svg"
          },
          {
            listItem:'Reporting and Analytics',
            image:"https://cdn.webhr.co/Website/images/modules/HelpDesk/Key_features/5.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    }
  },
  {
    metaDescription: "Optimize project outcomes with WebHR's Projects module, featuring task management, budget tracking, and detailed project analytics",
    title: 'Projects',
    slug: "projects",
    subTitle: "WebHR provides convenience to effectively manage and streamline organization projects, the projects module enables you to effectively manage the project task, ensuring the projects are completed on time and successful projects outcome. This module helps you to drive successful project outcomes, enhance productivity, and achieve organizational objectives.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Projects.png',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Seamlessly manage the projects Task Management and Assignment  ",
        sectionContent: "WebHR projects module helps you to break down the task and assign them to individual team members. At the time of adding the task, you can mention the task start and end time, task information, budget information, and who are the employees you will manage the task. This ensures smooth task execution and efficient collaboration. This module helps you to meet the task deadline and manage e the workload effectively.   ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Projects/Project01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Budget Management",
        sectionContent: "Managing the project budget is one of the crucial tasks that every organization must do regarding the project. From the project module, you can track project expenses and monitor project costs. You can define the regular and overtime rate of the project. This allows you to maintain the project cost and ensure projects are delivered within budget constraints.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Projects/Project02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Projects Reporting and Analytics",
        sectionContent: "The project module allows you to generate multiple reports that give you the capabilities that provide insights into project performance, resource utilization, and overall project success, you can generate project-specific reports, analyze project data, and gain valuable insights for future project planning. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Projects/Project03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Project Planning',
            image:"https://cdn.webhr.co/Website/images/modules/Projects/Key_features/1.svg"
          },
          {
            listItem:'Resource management',
            image:"https://cdn.webhr.co/Website/images/modules/Projects/Key_features/2.svg"
          },
          {
            listItem:'Task Management and Assignment',
            image:"https://cdn.webhr.co/Website/images/modules/Projects/Key_features/3.svg"
          },
          {
            listItem:'Project budget management',
            image:"https://cdn.webhr.co/Website/images/modules/Projects/Key_features/4.svg"
          },
          {
            listItem:'Project reports',
            image:"https://cdn.webhr.co/Website/images/modules/Projects/Key_features/5.svg"
          },
        ],
        isAttendenceEnd: true,
      },
    }
  },
  {
    metaDescription: "Explore over 500+ built-in reports with WebHR's Report Module, offering advanced analytics in both graphical and tabular formats, plus an Ad-hoc report generator",
    title: 'Reports',
    slug: "reports",
    subTitle: "Reports are undeniably a vital tool for any organization. They illuminate your company's key operations, offering a comprehensive view of internal insights that empower stakeholders and managers to lead a successful business. At WebHR, we understand the crucial role of reports. Thus, our system features over 250 unique reports, all customizable to align with your specific informational requirements.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Reports.png',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Ability to Apply Filters and Add Additional Fields for Specific Information",
        sectionContent: "For an even more precise perspective, filters and additional fields can be utilized while generating the report. Once generated, these reports can be easily printed, emailed directly from the system, or exported into five distinctive formats to accommodate your needs. These insightful reports are not just numbers on a page, they are strategic tools, designed to support your company's internal decision-making processes and ultimately drive your organization toward greater efficiency.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Reports/Reports01.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: " Comprehensive Organization Reports at your Fingertips",
        sectionContent: "This module contains comprehensive reports that provide insight into various aspects of the organization. These reports include Organizational structure, headcount, employee detailed report, employee leaves summary, leaves quota, employee salary, and many more. You and your stakeholders can use these reports to assess the overall health of the organization and identify the gap for improvements. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Reports/Reports02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Stay informed with WebHR Data Visualization and Analytics Reports",
        sectionContent: "The reports module of WebHR is visually appealing and comes with easy-to-understand formats such as tabular, graphs, and charts that allow you to analyze data trends, identify patterns, and drive meaningful insights. These visual representations of data help you to enhance the decision-making process.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Reports/Reports03.webp',
        demoButton:true,
        buttonText:"Schedule for free"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Data Security and Access Controls",
        sectionContent: "We understand that employee data is very sensitive information that you don’t want others to have access to, the reports module of WebHR ensures that only authorized person(s) can access and view the reports, this access control makes it easy for you to maintain data privacy and confidentiality. You can define each user’s roles and permission can be assigned to control and access levels on the reports.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Reports/Reports04.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: 'Key Features',
        sectionList: [
          {
            listItem:'Comprehensive Library: Over 250 customizable reports.',
            image:"https://cdn.webhr.co/Website/images/modules/Reports/Key_features/01.svg"
          },
          {
            listItem:'Advanced Customization: Ability to apply filters and add additional fields for specific information.',
            image:"https://cdn.webhr.co/Website/images/modules/Reports/Key_features/02.svg"
          },
          {
            listItem:'User-Friendly: Reports can be directly emailed, printed, or exported in five different formats.',
            image:"https://cdn.webhr.co/Website/images/modules/Reports/Key_features/03.svg"
          },
          {
            listItem:"Efficiency Enhancing: Tools that are aimed at increasing your organization's operational efficiency.",
            image:"https://cdn.webhr.co/Website/images/modules/Reports/Key_features/04.svg"
          },
          {
            listItem:'Empowers Decision Making: Reports designed to guide and enhance internal company decisions.',
            image:"https://cdn.webhr.co/Website/images/modules/Reports/Key_features/05.svg"
          },
        ],
        isAttendenceEnd: true,
      }
    }
  },
  {
    metaDescription: "Empower managers to acknowledge their subordinates with our Recognition Module, featuring awards and rewards to boost morale and performance",
    title: 'Recognition',
    slug: "recognition",
    subTitle: "The recognition module enables you to recognize and celebrate the contribution of your employees. WebHR gives you a platform for acknowledging and appreciating the employee efforts that ultimately help you to foster a positive work culture and boost employee motivation which helps the overall success and well-being of the organization.",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Recognition.png',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Appreciating the employee efforts",
        sectionContent: "The recognition module of WebHR allows you to recognize your employee’s achievements and contributions such as exceptional performance, milestones achieved, or contribution to a project. This promotes the culture of the organization where employees can celebrate each other’s accomplishments and it also creates a sense of team spirit and collaboration.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recognition/Recognition01.webp',
        demoButton:true,
        buttonText:""
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Social Recognition Wall",
        sectionContent: "An organization needs to recognize employees’ achievements and give them rewards, this helps you to retain the top talented employees. The recognition module allows you to publicly appreciate the employee, this fosters a sense of community and creates a positive buzz within the organization. You can give a shout-out such as giving them the badge with a certain amount to create a positive and supportive work environment. Recognizing the employees boosts employee morale, encourages high performance, and strengthens employee relationships.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recognition/Recognition02.webp',
        demoButton:true,
        buttonText:"Try for free"
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Recognition Leaderboards",
        sectionContent: "You can showcase top performers from the recognition leaderboard, this promotes healthy competition, encourages your employees to strive for excellence, and creates a sense of achievement within the organization. A recognition leaderboard can foster a work culture that motivates employees to actively participate in recognition programs.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recognition/Recognition03.webp',
        demoButton:true,
        buttonText:"Book a demo"
      },
      section4: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Keep your employees updated!",
        sectionContent: "Your employees will get real-time notifications and alerts when they are receiving recognition or when their peers’ achievements are being acknowledged. The employee will get these notifications by email, real-time alerts create immediate gratification and reinforce a culture of appreciation.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recognition/Recognition04.webp',
        demoButton:true,
        buttonText:""
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Employee Rewards and Redeem Mechanism",
        sectionContent: "The recognition module makes it easy for you to provide rewards and incentives to your employees as a form of recognition. You can set up a reward program where employees can earn the amount for their achievements, this amount can be redeemed through various methods such as redeeming as a bonus or savings. This not only helps you to retain the employees but also motivates them to continue delivering outstanding performance.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recognition/Recognition05.webp',
        demoButton:true,
        buttonText:""
      },
      section6: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Complete Recognition System",
        sectionContent: "WebHR recognition module provides reporting and analytics capabilities to track and measure the impact of recognition programs. You can generate multiple reports such as recognition rewards reports, reward balances, current balance reports, etc. These reports give you insights to make data-driven decisions for continuous improvements. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Recognition/Recognition06.webp',
        demoButton:true,
        buttonText:""
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionList: [
          {
            listItem:'Complete Recognition System',
            image:"https://cdn.webhr.co/Website/images/modules/Recognition/Icon/01.svg"
          },
          {
            listItem:'Digital Wallet',
            image:"https://cdn.webhr.co/Website/images/modules/Recognition/Icon/02.svg"
          },
          {
            listItem:'Customizable Reward Types',
            image:"https://cdn.webhr.co/Website/images/modules/Recognition/Icon/03.svg"
          },
          {
            listItem:'Redeem Rewards',
            image:"https://cdn.webhr.co/Website/images/modules/Recognition/Icon/04.svg"
          },
          {
            listItem:'Recognition reports',
            image:"https://cdn.webhr.co/Website/images/modules/Recognition/Icon/05.svg"
          },
          {
            listItem:'Multi-Level Approvals Setup',
            image:"https://cdn.webhr.co/Website/images/modules/Recognition/Icon/06.svg"
          },
          {
            listItem:'Leaderboard',
            image:"https://cdn.webhr.co/Website/images/modules/Recognition/Icon/07.svg"
          },
        ],
        isAttendenceEnd: true,
      }
    }
  },
  {
    metaDescription: "Streamline compliance with our HR Compliance module, designed to facilitate the easy generation of essential compliance documents",
    title: 'HR Compliance',
    slug: "hr-Compliance",
    subTitle: "WebHR understands the critical importance of HR compliance in today’s complex regulatory landscape. To help businesses maintain legal compliance, streamline processes, and mitigate risks, we offer a comprehensive HR Compliance Module. This module is designed to assist HR professionals in effectively managing compliance requirements, ensuring adherence to labour laws, and implementing best practices across their organizations. ",
    thumb: 'https://cdn.webhr.co/Website/images/modules/Gallery/Compliance.png',
    sections: {
      section1: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Empowering HR Compliance: WebHR's Specialized Add-On Module ",
        sectionContent: "Adhering to HR compliance standards is crucial to ensure the welfare of employees and safeguard against legal ramifications. It's a cornerstone of organizational governance. WebHR recognizes the importance of this practice and offers a specialized HR Compliance Add-On Module that serves as a comprehensive toolkit for HR practitioners. \n\nThis module provides access to an array of features that are meticulously crafted to streamline compliance management. It helps organizations stay updated with evolving regulations and fosters a culture of adherence. The WebHR 'HR Compliance' Add-On Module screen displays multiple forms that employees can fill out, including I9 and W4 forms, along with other organizational governance forms.\n\nThe module's central feature is the generation of compliance documents mandated by state or governmental authorities. HR professionals can easily track the submission of these documents, ensuring a seamless onboarding process for employees. \n\nIn essence, WebHR's Compliance Add-On Module is a proactive approach to compliance management that enables organizations to mitigate risks, uphold legal obligations, and fortify their reputation within the regulatory landscape. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Compliance/Compliance01.webp',
        demoButton:true,
        buttonText:""
      },
      section2: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Enhanced Compliance Oversight and Document Management ",
        sectionContent: "WebHR's HR Compliance Module is a powerful tool that helps organizations effectively monitor and report on compliance-related activities. This feature facilitates the administration and oversight of various compliance obligations, including employment contracts, workplace safety protocols, anti-discrimination laws, and more. With its centralized management and automated reporting capabilities, users can effortlessly generate accurate compliance reports and meet regulatory deadlines. By simplifying compliance document management, WebHR provides a centralized platform for creating, organizing, and maintaining compliance documents, ensuring consistent adherence to regulatory standards. ",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Compliance/Compliance02.webp',
        demoButton:true,
        buttonText:""
      },
      section3: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionHeading: "Compliance Training and Employee Awareness",
        sectionContent: "Building a compliant work environment starts with educating employees on regulatory requirements. WebHR's Compliance provides a platform to generate and deliver compliance documents requested by the state or government. HR professionals can track the HR compliance documents submitted by the employee during the onboarding process.",
        sectionImg1: 'https://cdn.webhr.co/Website/images/modules/Compliance/Compliance03.webp',
        demoButton:true,
        buttonText:""
      },
      section5: {
        attributes: {
          bg: Colors.bgBlue,
          shadow: Colors.blueShadow,
        },
        sectionList: [
          {
            listItem:'Centralized management of compliance policies and documents',
            image:"https://cdn.webhr.co/Website/images/modules/Compliance/Keyfeatures/1.svg"
          },
          {
            listItem:'Easily linked with onboarding section fo new joiners to have them submit Compliance related information',
            image:"https://cdn.webhr.co/Website/images/modules/Compliance/Keyfeatures/2.svg"
          },
          {
            listItem:'Insights for monitoring and managing compliance documents',
            image:"https://cdn.webhr.co/Website/images/modules/Compliance/Keyfeatures/3.svg"
          },
        ],
        isAttendenceEnd: true,
      }
    }
  },
]

export const getAllModule = () => {
  return new Promise((resolve, reject) => {
    resolve(moduleList)
  })
}

export const getModule = (slug) => {
  const moduleIndex = moduleList.findIndex((module) => module.slug === slug)
  const moduleData = moduleList[moduleIndex]
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(moduleData), 50)
  })
}
